import React, { useEffect, useState, useRef, useCallback } from "react";
import MultipleSelect from "../../components/MultipleSelect";
import ButtonComponent from "../../components/ButtonComponent";
import TableComponent from "../../components/TableComponent";
import { CiLocationArrow1 } from "react-icons/ci";
import { ConsoleSqlOutlined, PlusOutlined } from "@ant-design/icons";
import TableButtonComponent from "../../components/TableButtonComponent";
import listBlockedInventories from "../../../../utils/listBlockedInventories";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { FaCalendar } from "react-icons/fa";
import discountCalc from "../../../../utils/discountCalc";
import { useNavigate } from "react-router-dom";
import { MutatingDots } from "react-loader-spinner";
import handleLocationClick from "../../../../utils/handleLocationClick";
import convertS3ToCloudFront from "../../../../utils/convertS3ToCloudFront";
import { CloseOutlined } from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import {
  addProposalInventories,
  emptyProposalInventories,
} from "../../../toolkit/slices/proposalInventories/proposalInventorySlice";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ExcelJS from "exceljs";
import formatIndianNumber from "../../../../utils/formatIndianNumber";
import Slider from "react-slick";
import debounce from "lodash/debounce";
import { Link } from "react-router-dom";
import { FaStar } from "react-icons/fa";
import {
  Modal,
  Button,
  Checkbox,
  DatePicker,
  Input,
  Form,
  Select,
  InputNumber,
  Switch,
  Alert,
  AutoComplete,
  Spin,
  Tooltip,
  Table,
} from "antd";
import filterSearch from "../../../../utils/filterSearch";
import Trade from "./Trade";
import "./InventoryContainer.css";
import { FaPlus } from "react-icons/fa6";
import CustomInputComponent from "../../components/CustomInputComponent";
import { FaFilePen } from "react-icons/fa6";
import {
  addInventory,
  emptyDraft,
  getInventories,
  resetIsInventoryAdded,
  setSideTab,
} from "../../../toolkit/slices/inventories/inventorySlice";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../toolkit/slices/cart/cartSlice";
import { Row, Col, Carousel, notification } from "antd";
import moment from "moment";
import modalDemoImage from "../InventoryContainer/Picture1 2.svg";
import { MdHomeMax, MdOutlineFileDownload, MdDelete } from "react-icons/md";
import { CiEdit } from "react-icons/ci";
import { saveAs } from "file-saver";
import OOHProposalChitraB from "./OOHProposalChitraB.xlsx";
import { IoIosRefresh } from "react-icons/io";
import excel from "./excel.pdf";
import {
  resetCart,
  removeFromCart,
  updateCartData,
} from "../../../toolkit/slices/cart/cartSlice";
import * as XLSX from "xlsx";
import dateAvailability from "../../../../utils/dateAvailability";
import getProposalAvailableFromLabel from "../../../../utils/getProposalAvailableFromLabel";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import PptxGenJS from "pptxgenjs";
import { RiFacebookBoxFill } from "react-icons/ri";
import generateMC from "../../../../utils/generateMC";
import generatePC from "../../../../utils/generatePC";
import RectangleGenerator from "../../components/ReactangleGenerator";
import { dataImg } from "../../../../utils/dataImg";
// import file from 'OOH Proposal - Chitra B.xlsx'
import { useMediaQuery } from "@material-ui/core";
import isEmailAllowed from "../../../../utils/isEmailAllowed";
import isEliteUser from "../../../../utils/isEliteUser";
//images

import pptSliderCornerLogo from "../../assets/pptSlideCornerLogo.png";
import coverImage from "../../assets/pptSlide1.jpg";
import bottomRightLogo from "../../assets/pptSlide11.png";
import welcomeBackground from "../../assets/pptSlide111.jpg";
import welcomeText from "../../assets/welcomeText.png";
import welcomeHoarding from "../../assets/welcomeHoarding.png";
import svg1 from "../../assets/svg1.png";
import clientPageImage from "../../assets/clientPageImage.png";
import clientSpecificBorderLine from "../../assets/clientSpecificBorderLines.png";
import hoardingIcon from "../../assets/hoardingIcon.png";
import locationIcon from "../../assets/locationIcon.png";
import calendarIcon from "../../assets/calendarIcon.png";
import rupeeIcon from "../../assets/rupeeIcon.png";
import contactRightImage from "../../assets/contactRightImage.png";
import contactUsTitle from "../../assets/contactUsTitle.png";
import pptSlideLast from "../../assets/pptSlideLast.png";
import thankYouImage from "../../assets/thankYouImage.png";
import unitsIcon from "../../assets/units.png";
import amitImage from "../../assets/amit@4x.png";
import meetImage from "../../assets/meet@4x.png";
import niravImage from "../../assets/nirav@4x.png";
import pankajImage from "../../assets/pankaj@4x.png";
import sagarImage from "../../assets/sagar@4x.png";
import saurabhImage from "../../assets/saurabh@4x.png";
import vrajImage from "../../assets/vraj@4x.png";
import yellowspotImage from "../../assets/yellowspot@4x.png";
import fetchImageAsBase64 from "../../../../utils/fetchImageAsBase64";
import TextArea from "antd/es/input/TextArea";
import Share from "../../containers/ShareToOtherPlatforms/index";
import {
  addBlockInventories,
  emptyBlockInventories,
} from "../../../toolkit/slices/blockInventories/blockInventorySlice";

const settings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  vertical: true,
  verticalSwiping: true,
  dotsClass: "slick-dots slick-thumb custom-slick-dots",
  appendDots: (dots) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px",
      }}
    >
      <ul style={{ margin: "0px" }}> {dots} </ul>
    </div>
  ),
};
const { RangePicker } = DatePicker;
const { Option } = Select;

function InventoryContainer() {
  let finalurlPpt = null;
  let finalurlExcel = null;
  let propId = null;
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const sliderRef = useRef(null);
  const scrolling = useRef(false);
  const [applyPer, setApplyPer] = useState(false);

  //files download loader indicator
  const [showLoader, setShowLoader] = useState(false);
  const [buttonText, setButtonText] = useState("");
  const [vendors, setVendors] = useState([]);

  let userEmail = useSelector((state) => state.user.email);
  let uId = useSelector((state) => state.user._id);
  // const handleWheel = useCallback(
  //   _.throttle((e) => {
  //     if (scrolling.current) {
  //       return;
  //     }
  //     scrolling.current = true;

  //     if (e.deltaY < 0) {
  //       sliderRef.current.slickPrev();
  //     } else {
  //       sliderRef.current.slickNext();
  //     }
  //     setTimeout(() => {
  //       scrolling.current = false;
  //     }, 500); // Adjust the delay as needed
  //   }, 500), []);

  const [GSTNumber, setGSTNumber] = useState(null);
  const [activatePR, setActivatePR] = useState(false); //PR as in Package Rate amigos
  const [packageRate, setPackageRate] = useState(null);
  const [blockingModalOpen, setBlockingModalOpen] = useState(false);
  const [blockingSubmitLoading, setBlockingSubmitLoading] = useState(false);
  const [blockingOpen, setBlockingOpen] = useState(false);
  const [modalVisibleEmail, setModalVisible] = useState(false);
  const [emailContent, setEmailContent] = useState("");
  const [bookingsOpen, setBookingsOpen] = useState(false);
  const [proposalsOpen, setProposalsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [inventoryView, setInventoryView] = useState(false);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);
  const [bookInventories, setBookInventories] = useState(null);
  const [proposalInventories, setProposalInventories] = useState(null);
  const [blockedInventories, setBlockedInventories] = useState(null);
  const [blockInvWhole, setBlockInvWhole] = useState(null);
  const [blockingType, setBlockingType] = useState("normal");
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [dataSource, setDataSource] = useState(null);
  const [clientName, setClientName] = useState(null);
  const [clientDropdownOptions, setClientDropdownOptions] = useState([]);
  const [subject, setSubject] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewURLs, setPreviewURLs] = useState([]);
  const [addInventoryBoolean, setAddInventoryBoolean] = useState(false);
  const [openTradingInvs, setOpenTradingInvs] = useState(false);
  const [allTradingInv, setAllTradingInv] = useState(null);
  const [allTradingInvD, setAllTradingInvD] = useState(null);
  const [tradingSearchText, setTradingSearchText] = useState("");
  const [loadingTradingInvs, setLoadingTradingInvs] = useState(false);
  const [loadingRemovedInvs, setLoadingRemovedInvs] = useState(false);
  const [inventoryPickerType, setInventoryPickerType] = useState("trading");
  const [imageUrl, setImageUrl] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [flag, setFlag] = useState(false);
  const [forceRender, setForceRender] = useState(false);
  const [selectedEmails, setSelectedEmail] = useState(null);
  const [inputEmail, setInputEmail] = useState("");
  const [itemsForMV, setItemsForMV] = useState([]);
  //STAMP PURPOSE
  const [clientId, setClientId] = useState(null);
  const [emailSrNo, setEmailSrNo] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [emailOptions, setEmailOptions] = useState([]);
  let inventoriesV = useSelector((state) => state.inventoriesList.inventories);
  const [clientNames, setClientNames] = useState(null);
  const [finalUrl1, setFinalUrl1] = useState(null);
  const [finalUrl2, setFinalUrl2] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 1; // Number of items per page
  const isMobile = useMediaQuery("(max-width:769px)");
  const totalPages = Math.ceil(proposalInventories?.length / itemsPerPage);
  const [form] = Form.useForm();
  const [startDate, setStartDate] = useState(null);
  const [confirmedBy, setConfirmedBy] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [campaignName, setCampaignName] = useState("");
  const [isCartUpdated, setIsCartUpdated] = useState(false);
  const [bodyOfEmail, setBodyOfEmail] = useState("");
  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  useEffect(() => {
    if (clientNames) {
      setClientDropdownOptions(
        clientNames.map((client) => ({
          value: client.value,
          label: client.label,
        })),
      );
    } else {
      setClientDropdownOptions([]);
    }
  }, [clientNames]);

  // const isInventoryAdded = useSelector(
  //   (state) => state.inventoriesList.isInventoryAdded
  // );
  useEffect(() => {
    setBodyOfEmail(`<p>Dear Sir,</p>
    <br/>
    <p>Please find below the links to download the proposal documents:</p>
    <br/>
    <p><a href="${encodeURI(
      finalUrl1,
    )}">Download PowerPoint presentation</a></p>
    <br/>
    <p><a href="${encodeURI(finalUrl2)}">Download Excel file</a></p>
    <br/>
    <p>Awaiting your positive response for the same.</p>
    <br/>
    <p>Best regards,</p>
    <br/>
    <p>Yellow Spot</p>
    <br/>
   `);
  }, [finalUrl1, finalUrl2]);

  useEffect(() => {
    // Update subject when clientName changes and clientName.label is valid
    if (clientName && clientName.label) {
      setSubject(
        "OOH Proposal for " +
        clientName.label +
        `${emailSrNo ? ` #${emailSrNo}` : ``}`,
      );
    }
  }, [clientName, emailSrNo]);
  useEffect(() => {
    dispatch(getInventories());
    dispatch(setSideTab(window.location.pathName));
  }, []);
  useEffect(() => {
    let typesD = inventoriesV.map((ele) => {
      return ele?.typeOfMedia?.name;
    });
    let typesU = Array.from(new Set(typesD)).map((ele) => {
      return {
        label: ele,
        value: ele,
      };
    });
    setItemsForMV(typesU);
  }, [inventoriesV]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (addInventoryBoolean) {
      fetchVendors();
    }
  }, [addInventoryBoolean]);

  const fetchVendors = async () => {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllTradingParties`,
        {
          method: "GET",
          credentials: "include",
        },
      );
      let responseJson = await response.json();

      if (responseJson?.success) {
        const vendorList = responseJson?.data?.map((party) => ({
          name: party?.name,
          gstNumber: party?.gstNumber,
        }));
        setVendors(vendorList);
      }
    } catch (error) {
      console.error("Error fetching vendors:", error);
    }
  };

  const onFinish = async (values) => {
    let data = {
      locations: {
        city: values.city,
        Area: values.area,
        name: values.name,
      },
      Illu: values.illu,
      width: values.width,
      height: values.height,
      CodeNo: values.codeNo,
      CASCode: values.casCode,
      typeOfMedia: values.mediaType,
      img: imageUrl,
      vendor: values.vendor,
      ownedBy: values.vendor,
      ratePerMonth: values.ratePerMonth,
      lat: values.lat,
      lng: values.lng,
      PurchaseRate: values.PurchaseRate,
      isTrading: true,
      suffix: values.suffix,
    };
    // dispatch(addInventory(data));
    let requestBody = data;
    await addSingleTradingInventory(requestBody);
    form.resetFields();
    setSelectedImage(null);
  };
  const addSingleTradingInventory = async (body) => {
    try {
      const inventoryResponse = await fetch(
        `${apiBaseUrl}/inventoryManagement`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(body),
        },
      );

      if (inventoryResponse.ok) {
        const responseData = await inventoryResponse.json();
        const newInventory = responseData.inventory;
        notification.success({ message: responseData.message });
        dispatch(addToCart(newInventory));
        setAddInventoryBoolean(false);
      } else {
        const responseData = await inventoryResponse.json();

        if (responseData.error) {
          notification.error({ message: responseData.error });
        }
        // Do not add to frontend when API returned error (e.g. Inventory already exists)
        setAddInventoryBoolean(false);
      }
    } catch (error) {
      console.log("Error during inventory insertion:", error.message);
    }
  };

  const mapTradingInvForPicker = (ele) => ({
    ...ele,
    locationName: ele.locations?.name,
    checked: false,
  });

  const displayTradingInvs = async () => {
    setInventoryPickerType("trading");
    setLoadingTradingInvs(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllTradingInventories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        },
      );
      const data = await response.json();
      if (!data.success) {
        notification.error({
          message: data.error || "Failed to fetch trading inventories.",
        });
        return;
      }
      const filteredInventories = (data.allTradingInventories || []).filter(
        (itemB) => !cart?.some((itemA) => itemA?._id === itemB?._id),
      );
      const mapped = filteredInventories.map(mapTradingInvForPicker);
      setAllTradingInv(mapped);
      setAllTradingInvD(mapped);
      setTradingSearchText("");
      setOpenTradingInvs(true);
    } catch (error) {
      console.error("Failed to fetch trading inventories:", error);
      notification.error({
        message: "Failed to load trading inventories. Please try again.",
      });
    } finally {
      setLoadingTradingInvs(false);
    }
  };

  const displayRemovedInvs = async () => {
    setInventoryPickerType("removed");
    setLoadingRemovedInvs(true);
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/getAllRemovedInventories`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
        },
      );
      const data = await response.json();
      if (!data.success) {
        notification.error({
          message: data.error || "Failed to fetch removed inventories.",
        });
        return;
      }
      const filteredInventories = (data.allRemovedInventories || []).filter(
        (itemB) => !cart?.some((itemA) => itemA?._id === itemB?._id),
      );
      const mapped = filteredInventories.map(mapTradingInvForPicker);
      setAllTradingInv(mapped);
      setAllTradingInvD(mapped);
      setTradingSearchText("");
      setOpenTradingInvs(true);
    } catch (error) {
      console.error("Failed to fetch removed inventories:", error);
      notification.error({
        message: "Failed to load removed inventories. Please try again.",
      });
    } finally {
      setLoadingRemovedInvs(false);
    }
  };

  const handleTradingPickerCheckboxChange = (e, record) => {
    const { checked } = e.target;
    const updatedData = allTradingInvD.map((item) => {
      if (item._id === record._id) {
        return { ...item, checked };
      }
      return item;
    });
    setAllTradingInvD(updatedData);
    setAllTradingInv(filterSearch(tradingSearchText, updatedData));
  };

  let tradingPickerDebounceTimer;
  const handleTradingPickerFilterData = (e) => {
    clearTimeout(tradingPickerDebounceTimer);
    setTradingSearchText(e.target.value);
    tradingPickerDebounceTimer = setTimeout(() => {
      setAllTradingInv(filterSearch(e.target.value, allTradingInvD));
    }, 500);
  };

  const handleOkOfTradingInv = () => {
    const selected = allTradingInv?.filter((ele) => ele.checked) || [];
    if (selected.length === 0) {
      notification.warning({ message: "Please select at least one inventory." });
      return;
    }
    selected.forEach((inv) => dispatch(addToCart(inv)));
    const inventoryLabel =
      inventoryPickerType === "removed" ? "removed" : "trading";
    notification.success({
      message: `${selected.length} ${inventoryLabel} ${
        selected.length === 1 ? "inventory" : "inventories"
      } added to cart.`,
    });
    setOpenTradingInvs(false);
    setTradingSearchText("");
    setAllTradingInv(null);
    setAllTradingInvD(null);
  };

  const handleCloseTradingInv = () => {
    setOpenTradingInvs(false);
    setAllTradingInv(null);
    setAllTradingInvD(null);
    setTradingSearchText("");
  };

  const columnsForTradingInvs = [
    ...(inventoryPickerType === "removed"
      ? [
          {
            title: "Code No",
            dataIndex: "CodeNo",
            key: "codeNo",
          },
        ]
      : []),
    {
      title: "Vendor",
      dataIndex: "ownedBy",
      key: "vendor",
    },
    {
      title: "Location Area",
      dataIndex: "locationName",
      key: "locationName",
    },
    {
      title: "Width",
      dataIndex: "width",
      key: "width",
    },
    {
      title: "Height",
      dataIndex: "height",
      key: "height",
    },
    {
      title: "Illumination",
      dataIndex: "Illu",
      key: "Illu",
    },
    {
      title: "Add",
      dataIndex: "add",
      key: "add",
      render: (_, record) => (
        <Checkbox
          checked={record.checked}
          onChange={(e) => handleTradingPickerCheckboxChange(e, record)}
        />
      ),
    },
  ];

  // useEffect(() => {
  //   if (isInventoryAdded) {
  //     notification.success({
  //       message: "Success",
  //       description: "Inventory added successfully",
  //       onClose: () => dispatch(resetIsInventoryAdded()),
  //     });
  //   }
  // }, [isInventoryAdded, dispatch]);

  useEffect(() => {
    if (flag) {
      handleFileSelectOfPreview();
    }
  }, [flag]);

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputLabel, setInputLabel] = useState("");

  const fetchSuggestions = (query) => {
    if (query && clientNames) {
      setLoading(true);
      const filteredClients = clientNames
        .filter((client) =>
          client.label.toLowerCase().includes(query.toLowerCase()),
        )
        .map((client) => ({ value: client.value, label: client.label }));
      setOptions(filteredClients);
      setLoading(false);
    } else {
      setOptions([]);
    }
  };
  const onSearch = (value) => {
    setInputValue(value);
    setInputLabel(""); // Clear the input label to show the user's input
    fetchSuggestions(value);
  };

  const onSelect = (value, option) => {
    if (!option) return; // typed value not in list (e.g. in Block modal Select)
    setInputValue(value);
    setInputLabel(option.label); // Set the input label to the selected option's label
    setClientName(option);
  };

  // const onBlur = () => {
  //   if (!inputLabel) {
  //     setClientName(inputValue);
  //   }
  // };
  const modules = {
    toolbar: [
      [
        { bold: true },
        { italic: true },
        { underline: true },
        { link: true },
        { emoji: true },
      ],
    ],
  };

  const formats = ["bold", "italic", "underline", "link", "emoji"];

  const handleTextArea = (value) => {
    setBodyOfEmail(value);
    console.log("This vallll", value);
  };
  const onClear = () => {
    setInputValue("");
    setInputLabel("");
    setClientName(null);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await fetch(
          `${apiBaseUrl}/inventoryManagement/displayPartyCompanies`,
          {
            method: "GET",
            credentials: "include",
          },
        );
        let responseJson = await response.json();
        let options = responseJson?.data.map((ele) => ({
          label: ele.name,
          value: ele._id,
        }));
        console.log(options);
        setClientNames(options);

        // Wait for updateCartData to complete
        await dispatch(updateCartData());
        setIsCartUpdated(true); // Set the flag when the process completes
      } catch (err) {
        console.error(`Error: ${err.message}`);
      }
    };
    fetchData();
  }, [apiBaseUrl, dispatch]);

  const handleUpload = () => {
    document.querySelector(".add-inventory-image-upload input").click();
  };

  const handleEmailSelect = (selectedItems) => {
    setSelectedEmail(selectedItems);
  };

  // const handleInputChange = (value) => {
  //   setInputEmail(value);
  // };
  const handleInputConfirm = () => {
    if (inputEmail && !selectedEmails.includes(inputEmail)) {
      setSelectedEmail([...selectedEmails, inputEmail]);
      setInputEmail("");
    }
  };

  useEffect(() => {
    if (flag) {
      handleFileSelectOfPreview();
    }
  }, [flag]);
  const handleScroll = useCallback(
    debounce((e) => {
      if (e.deltaY > 0 && currentPage < totalPages - 1) {
        setCurrentPage(currentPage + 1);
      } else if (e.deltaY < 0 && currentPage > 0) {
        setCurrentPage(currentPage - 1);
      }
    }, 100),
    [currentPage, totalPages],
  );
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "ArrowDown" && currentPage < totalPages - 1) {
        setCurrentPage(currentPage + 1);
      } else if (e.key === "ArrowUp" && currentPage > 0) {
        setCurrentPage(currentPage - 1);
      }
    },
    [currentPage, totalPages],
  );
  useEffect(() => {
    const slider = sliderRef.current;
    if (slider) {
      slider.addEventListener("wheel", handleScroll);
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        slider.removeEventListener("wheel", handleScroll);
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [handleScroll, handleKeyDown]);

  const renderPagination = (totalPages, currentPage, setCurrentPage) => {
    const pageNumbers = [];
    const maxVisiblePages = 5;
    const halfVisiblePages = Math.floor(maxVisiblePages / 2);

    let startPage = Math.max(currentPage - halfVisiblePages, 0);
    let endPage = Math.min(startPage + maxVisiblePages - 1, totalPages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(endPage - maxVisiblePages + 1, 0);
    }

    if (startPage > 0) {
      pageNumbers.push(
        <div
          key="start-ellipsis"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="ellipsis"></div>
          <div className="ellipsis"></div>
          <div className="ellipsis"></div>
        </div>,
      );
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <div
          key={i}
          className={`circle ${i === currentPage ? "active" : ""}`}
          onClick={() => setCurrentPage(i)}
        >
          {i + 1}
        </div>,
      );
    }

    if (endPage < totalPages - 1) {
      pageNumbers.push(
        <div
          key="end-ellipsis"
          style={{ display: "flex", flexDirection: "column" }}
        >
          <div className="ellipsis"></div>
          <div className="ellipsis"></div>
          <div className="ellipsis"></div>
        </div>,
      );
    }

    return <div className="pagination">{pageNumbers}</div>;
  };

  const handleFileChange = (event) => {
    // setSelectedFiles([])
    setFlag(false);
    const files = Array.from(event.target.files);
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }

    // List of allowed MIME types for images and videos
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/gif",
      "image/jpg",
      "image/heic",
      "video/mp4",
      "video/webm",
      "video/ogg",
      "video/x-msvideo", // AVI
      "video/quicktime", // MOV
      // Add more MIME types as needed
    ];

    // Check if any selected file is not an allowed type
    const hasNonAllowedType = files.some(
      (file) => !allowedTypes.includes(file.type),
    );

    if (hasNonAllowedType) {
      notification.error({
        message: "You are only allowed to upload image.",
      });

      // Clear the selected files
      event.target.value = null;
      return;
    }

    // Create an array of FileReaders to read the selected files
    const readers = files.map((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        setPreviewURLs((prevPreviewURLs) => [
          ...prevPreviewURLs,
          reader.result,
        ]);
      };
      reader.readAsDataURL(file);
      return reader;
    });
    event.target.value = null;

    // Set the selectedFiles state after processing the files
    setSelectedFiles([]);
    setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, ...files]);
    setFlag(true);
    // event.target.value = "";
  };

  const handleFileSelectOfPreview = async () => {
    for (const file of selectedFiles) {
      const typeOfFile = file.type;
      const requestBody = {
        fileName: encodeURIComponent(file.name),
        mime: typeOfFile,
        "Content-Type": typeOfFile,
        acl: "public-read",
      };
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/uploadPolicy`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        },
      );
      const data = await response.json();

      if (!data?.data?.fields || !data?.data?.url) {
        continue;
      }

      const formData = new FormData();
      const expectedContentType = typeOfFile || "image/jpeg";

      Object.entries(data.data.fields).forEach(([key, value]) => {
        if (
          key.toLowerCase() === "content-type" ||
          key.toLowerCase() === "mime"
        ) {
          formData.append(key, expectedContentType);
        } else {
          formData.append(key, value);
        }
      });

      if (
        !formData.has("Content-Type") &&
        !formData.has("content-type") &&
        !formData.has("mime")
      ) {
        formData.append("Content-Type", expectedContentType);
      }

      formData.append("file", file);

      try {
        const almostFinalResponse = await fetch(data.data.url, {
          method: "POST",
          body: formData,
        });

        if (almostFinalResponse.ok) {
          const key = data.data.fields?.key ?? data.filePath;
          const finalurl = convertS3ToCloudFront(
            `${data.data.url}/${encodeURIComponent(key)}`,
          );
          setImageUrl(finalurl);
          console.log("Preview image uploaded successfully:", finalurl);
        } else {
          console.log(
            "Error occurred:",
            almostFinalResponse.status,
            almostFinalResponse.statusText,
          );
        }
      } catch (error) {
        console.log("Error occurred:", error);
      }
    }
  };
  //This is a data source used incase we want to reuse the whole modified inventories
  const cart = useSelector((state) => state.cartSpace.cart);
  const [dataSourceB, setDataSourceB] = useState(null);

  const [inventories, setInventories] = useState(null);
  const [checkedRecords, setCheckedRecords] = useState({});

  const handleCheckboxChange = (e, record) => {
    const { checked } = e.target;
    setCheckedRecords((prevState) => ({
      ...prevState,
      [record._id]: checked,
    }));
  };
  const handleActivatePR = () => {
    setActivatePR((prev) => {
      if (prev) {
        setPackageRate(0);
      }
      return !prev;
    });
  };
  useEffect(() => {
    setInventories(cart);
  }, [cart]);
  useEffect(() => {
    if (inventories?.length > 0 && cart.length > 0) {
      let info = [];
      // console,log("thhhh",inventories);
      inventories.forEach((item) => {
        console.log("Item is: ", item);
        info.push({
          _id: item?._id,
          CodeNo: item?.CodeNo,
          width: item?.width,
          height: item?.height,
          typeOfMedia: item?.typeOfMedia?.name,
          Area: item?.locations?.name,
          Availability: item.isTrading
            ? item.Availability
            : dateAvailability(
              item?.Bookings && item?.Bookings.length > 0
                ? item?.Bookings
                : [],
              false,
              item,
            ).status,
          ratePerMonth: item?.ratePerMonth,
          maintenanceRate: item?.maintenanceRate,
          unit: item?.unit ? item.unit : 1,
          isTrading: item?.isTrading,
          Bookings: item?.Bookings,
          blockedDates: item?.blockedDates,
        });
      });

      setDataSource(info);
      setDataSourceB(info);
    }
  }, [inventories, forceRender, cart]);

  console.log("data source: ", dataSource);

  // helps you select view the selected records in the modal
  useEffect(() => {
    if (inventories?.length > 0 && bookingModalOpen) {
      let info = [];
      inventories.forEach((item) => {
        if (checkedRecords[item._id]) {
          info.push({
            _id: item._id,
            CodeNo: item.CodeNo,
            typeOfMedia: item?.typeOfMedia?.name,
            Availability: item.Availability,
          });
        }
      });
      setBookInventories(info);
    }
  }, [bookingModalOpen]);

  //fetch emails
  useEffect(() => {
    async function fetchEmails() {
      try {
        let response = await fetch(
          `${apiBaseUrl}/inventoryManagement/listEmails`,
          {
            method: "GET",
            credentials: "include",
          },
        );
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        let responseJson = await response.json();
        let emails = responseJson?.emails?.map((ele) => ele.emailId) || [];
        setEmailOptions(emails);
      } catch (error) {
        console.error("Error fetching emails:", error);
      }
    }
    fetchEmails();
  }, []);

  const showModalEmail = () => {
    // Fetch email content or set it from so\mewhere else
    const emailContent = "Your email content goes here";
    setEmailContent(emailContent);
    setModalVisible(true);
  };

  const saveEmailIfItsNew = async (emails) => {
    let newEmails = emails.filter((ele) => !emailOptions.includes(ele));
    let requestBody = {
      emails: newEmails,
    };
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/saveNewEmails`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );
      let responseJSON = response.json();
      if (response.ok) {
        console.log(responseJSON.message);
      }
    } catch (err) {
      notification.error({ message: err.message, duration: 0.3 });
    }
  };
  const handleOkEmail = async () => {
    try {
      let source = "";

      if (userId == "6655da0d21d3e92d1b400e27") {
        source = "sales@yellowspot.in";
      } else if (userId == "6655d9b40777525410c88982") {
        source = "aksha.shah@yellowspot.in";
      } else if (userId == "6655da0db7fa235637d8803a") {
        source = "mediaplanning@yellowspot.in";
      } else if (userId == "668bb8a8dc1b17763bfc16bd") {
        source = "pankaj.vyas@yellowspot.in";
      } else if (userId == "668bb8a98846df09d6649fc3") {
        source = "meet.javia@yellowspot.in";
      } else if (userId == "668bb8a86a5e8031326ead83") {
        source = "saurabh.sharma@yellowspot.in";
      } else if (userId == "6655d9b40777525410c88982") {
        source = "aksha.shah@yellowspot.in";
      } else if (userId == "6655da0d21d3e92d1b400e27") {
        source = "sales@yellowspot.in";
      }

      const requestBody = {
        subject,
        email: selectedEmails,
        finalUrl1,
        finalUrl2,
        source,
        userId,
        bodyOfEmail,
      };

      const response = await fetch(
        `${apiBaseUrl}/autosend/sendEmailForYellowSpotForWeb`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      const data = await response.json();
      if (data.success) {
        notification.success({ message: "Email has been sent successfully" });
        await saveEmailIfItsNew(selectedEmails);
        await generateEmailSrNo();
        navigate("/approvals");
      } else {
        notification.error({ message: data.message });
      }
    } catch (error) {
      notification.error({ message: error.message });
    }
    setModalVisible(false);
  };
  const generateEmailSrNo = async () => {
    try {
      if (proposalId && clientId && emailSrNo) {
        let requestBody = {
          id: proposalId,
          clientId: clientId,
          emailSrNo: emailSrNo,
        };
        let response = await fetch(
          `${apiBaseUrl}/inventoryManagement/setUpEmailSrNoProposal`,
          {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          },
        );
        let responseJson = await response.json();
        if (response.ok) {
          console.log("Email serial Number is generated");
        }
      }
    } catch (error) {
      console.error(`Error:${error.message}`);
    }
  };

  const handleCancelEmail = () => {
    setModalVisible(false);
  };
  // helps you select view the selected records in the proposal modal
  useEffect(() => {
    if (inventories?.length > 0 && isModalOpen) {
      console.log("💀💀💀💀", inventories);
      let info = [];
      inventories.forEach((item) => {
        if (checkedRecords[item._id]) {
          info.push({
            _id: item._id,
            codeNo: item.CodeNo,
            vendor: item.vendor,
            img: item.img,
            area: item.locations.Area,
            location: item.locations.name,
            mediaVehicle: item.typeOfMedia.name,
            width: item.width,
            height: item.height,
            Illu: item.Illu,
            Bookings: item.Bookings,
            premiumBlock: item?.premiumBlock,
            focBookings: item?.focBookings,
            rotationalBookings: item?.rotationalBookings,
            blockedDates: item.blockedDates,
            sqFt: item.width * item.height,
            mountingCharge: activatePR
              ? 0
              : generateMC(
                item.width,
                item.height,
                item.Illu,
                item?.unit,
                item?.typeOfMedia?.name,
              ),
            printingCharge: activatePR
              ? 0
              : generatePC(
                item.width,
                item.height,
                item.Illu,
                item?.unit,
                item?.typeOfMedia?.name,
              ),
            specialRate: activatePR ? 0 : item.ratePerMonth,
            specialRatePerMonth: activatePR ? 0 : item.ratePerMonth,
            innovationRate: 0,
            ratePerMonth: item.ratePerMonth,
            maintenanceRate: item?.maintenanceRate,
            lat: item?.lat,
            lng: item?.lng,
            unit: item?.unit,
            Availability: getProposalAvailableFromLabel(item),
            isTrading: item?.isTrading,
            isArchived: item?.isArchived,
            removedOn: item?.removedOn,
            half1Id: item?.half1Id,
            half2Id: item?.half2Id,
            fullId: item?.fullId,
          });
        }
      });

      setProposalInventories(info);
    }
  }, [isModalOpen, activatePR]);
  useEffect(() => {
    let flag = false;
    if (proposalInventories?.length > 0) {
      proposalInventories.map((ele) => {
        // console.log(ele.specialRate,ele.ratePerMonth)
        if (discountCalc(ele.specialRate, ele.ratePerMonth) > 20) {
          flag = true;
        }
      });

      if (flag && !isEmailAllowed(userEmail)) {
        setButtonText("Create Request");
      } else {
        setButtonText("Generate Proposal");
      }
    }
    if (proposalInventories?.length == 0) {
      setProposalsOpen(false);
      setBlockingOpen(false);
      setBookingsOpen(false);
    }
  }, [proposalInventories]);
  useEffect(() => {
    if (inventories?.length > 0 && blockingModalOpen) {
      let info = [];
      inventories.forEach((item) => {
        if (checkedRecords[item._id]) {
          info.push(item._id);
        }
      });
      if (blockingType === "premium") {
        let data = [];
        inventories.forEach((item) => {
          if (checkedRecords[item._id]) {
            data.push({
              _id: item._id,
              codeNo: item.CodeNo,
              vendor: item.vendor,
              img: item.img,
              area: item.locations.Area,
              location: item.locations.name,
              mediaVehicle: item.typeOfMedia.name,
              width: item.width,
              height: item.height,
              Illu: item.Illu,
              Bookings: item.Bookings,
              premiumBlock: item.premiumBlock,
              blockedDates: item.blockedDates,
              sqFt: item.width * item.height,
              specialRatePerMonth: item.ratePerMonth,
              innovationRate: 0,
              ratePerMonth: item.ratePerMonth,
              rpm: item.ratePerMonth,
              lat: item?.lat,
              lng: item?.lng,
              unit: item?.unit,
              // specialRate: activatePR ? 0 : item.ratePerMonth,
              // Availability: item?.Availability,
              // isTrading: item?.isTrading,
              // half1Id: item?.half1Id,
              // half2Id: item?.half2Id,
              // fullId: item?.fullId,
            });
          }
        });
        setBlockInvWhole(data);
      }
      setBlockedInventories(info);
    }
  }, [blockingModalOpen, blockingType]);
  useEffect(() => {
    if (proposalInventories?.length > 0) {
      setProposalInventories((prevInventories) =>
        prevInventories.map((inventory) => ({
          ...inventory,
          specialRate: applyPer
            ? inventory.ratePerMonth * 0.8
            : inventory.ratePerMonth,
        })),
      );
    }
  }, [applyPer]);

  // function everyRecordsChecked(records) {
  //     const values = Object.values(records);
  //     const allValuesTrue = values.length > 0 && values.every(value => value === true);
  //     return allValuesTrue
  // }
  // async function convertImageUrlToBase64(url) {
  //     try {
  //         const response = await fetch(url);
  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }
  //         const blob = await response.blob();
  //         return new Promise((resolve, reject) => {
  //             const reader = new FileReader();
  //             reader.onload = () => {
  //                 resolve(reader.result.split(',')[1]); // Extract base64 string (remove data URL prefix)
  //             };
  //             reader.onerror = reject;
  //             reader.readAsDataURL(blob);
  //         });
  //     } catch (error) {
  //         throw new Error('Failed to fetch image and convert to base64');
  //     }
  // }

  // async function processProposalInventories(proposalInventories) {
  //     try {
  //         const modifiedProposalInventories = await Promise.all(proposalInventories.map(async (proposal) => {
  //             const base64Image = await convertImageUrlToBase64(proposal.img);
  //             return {
  //                 ...proposal,
  //                 img: base64Image
  //             };
  //         }));
  //         return modifiedProposalInventories;
  //     } catch (error) {
  //         throw new Error(error.message);
  //     }
  // }

  async function generatePresentation() {
    const pptx = new PptxGenJS();
    const effectiveClientName =
      (clientName && clientName.label)
        ? clientName.label
        : (inputValue && inputValue.trim())
          ? inputValue.trim()
          : "";
    try {
      const imageUrls = [
        coverImage,
        bottomRightLogo,
        welcomeBackground,
        welcomeText,
        welcomeHoarding,
        svg1,
        pptSliderCornerLogo,
        clientPageImage,
        clientSpecificBorderLine,
        hoardingIcon,
        locationIcon,
        rupeeIcon,
        unitsIcon,
        calendarIcon,
        contactRightImage,
        contactUsTitle,
        pptSlideLast,
        thankYouImage,
      ];

      const [
        coverImageBase64,
        bottomRightLogoBase64,
        welcomeBackgroundBase64,
        welcomeTextBase64,
        welcomeHoardingBase64,
        svg1Base64,
        pptSliderCornerLogoBase64,
        clientPageImageBase64,
        clientSpecificBorderLineBase64,
        hoardingIconBase64,
        locationIconBase64,
        rupeeIconBase64,
        unitsIconBase64,
        calendarIconBase64,
        contactRightImageBase64,
        contactUsTitleBase64,
        pptSlideLastBase64,
        thankYouImageBase64,
      ] = await Promise.all(imageUrls.map(fetchImageAsBase64));

      // Choose dynamic contact details image based on userId
      let contactDetailsImage = yellowspotImage;
      if (userId === "6655da0d21d3e92d1b400e27") {
        // Amit
        contactDetailsImage = amitImage;
      } else if (userId === "668bb8a8dc1b17763bfc16bd") {
        // Pankaj
        contactDetailsImage = pankajImage;
      } else if (userId === "668bb8a98846df09d6649fc3") {
        // Meet
        contactDetailsImage = meetImage;
      } else if (userId === "668bb8a86a5e8031326ead83") {
        // Saurabh
        contactDetailsImage = saurabhImage;
      } else if (userId === "6655da3e6826d0540967b9ce") {
        // Sagar
        contactDetailsImage = sagarImage;
      } else if (userId === "68636e2a8e9cb38030bb14f7") {
        // Nirav
        contactDetailsImage = niravImage;
      } else if (userId === "6655da0db7fa235637d8803a") {
        // Vraj
        contactDetailsImage = vrajImage;
      }

      const contactDetailsBase64 =
        await fetchImageAsBase64(contactDetailsImage);

      const hasSpecialRateChanged = proposalInventories.some(
        (ele) => ele?.ratePerMonth !== ele?.specialRate,
      );
      //🤡🤡 Cover slide
      const coverSlide = pptx.addSlide();
      // coverSlide.background = { path: "/images/pptSlide111.png", opacity: 50 };
      coverSlide.addImage({
        data: coverImageBase64, // Path to the image file
        x: 0, // x-coordinate (right corner of the slide is at x = 10, so 7.5 is near the right)
        y: 0, // y-coordinate (top corner of the slide)
        w: "100%", // width of the image
        h: "100%", // height of the image
      });
      //rightbottomCorner
      coverSlide.addImage({
        data: bottomRightLogoBase64,
        x: "94%",
        y: "89.4%",
        w: 0.6,
        h: 0.6,
      });

      //🤡🤡 Welcome slide
      const welcomeSlide = pptx.addSlide();
      welcomeSlide.background = { data: welcomeBackgroundBase64, opacity: 50 };
      let textWelcomeX = 0.4;
      let textWelcomeY = 0.23;
      welcomeSlide.addImage({
        data: welcomeTextBase64,
        x: textWelcomeX,
        y: textWelcomeY,
        h: 1.2,
        w: 2.8,
      });
      let welcomeInfo1 =
        "YellowSpot emerged as a collaborative effort between Het Graphics and Khushi Advertising. Our Strategic alliance brings together two industry leaders, establishing one of the most formidable media houses in Gujarat. ";
      let welcomeInfo2 =
        "We offer 400+ premium back-lit outdoor media throughout the city of Ahmedabad, located in high-traffic locations, and strategically placed in every neighborhood.";
      welcomeSlide.addText(welcomeInfo1, {
        x: textWelcomeX,
        y: textWelcomeY + 2,
        w: 4,
        fontSize: 17,
        // bold: true,
        wrap: true,
        color: "FFFFFF",
      });
      welcomeSlide.addText(welcomeInfo2, {
        x: textWelcomeX,
        y: textWelcomeY + 3.8,
        w: 4,
        fontSize: 17,
        // bold: true,
        wrap: true,
        color: "FFFFFF",
      });
      welcomeSlide.addImage({
        data: welcomeHoardingBase64,
        x: 4,
        y: -0.28,
        w: "60%",
        h: "110%",
      });
      //rightTopcorner
      welcomeSlide.addImage({
        data: svg1Base64,
        x: "90%",
        y: -0.3,
        w: 1.3,
        h: 1.3,
      });
      welcomeSlide.addImage({
        data: pptSliderCornerLogoBase64,
        x: "80%",
        y: "88%",
        w: 2,
        h: 0.7,
      });

      //🤡🤡 Client Specific Slide
      const clientSlide = pptx.addSlide();
      clientSlide.background = { data: welcomeBackgroundBase64, opacity: 50 };
      clientSlide.addImage({
        data: svg1Base64,
        x: "90%",
        y: -0.3,
        w: 1.3,
        h: 1.3,
      });
      clientSlide.addImage({
        data: clientPageImageBase64,
        x: 0,
        y: 1,
        w: "100%",
        h: 1.8,
      });
      clientSlide.addImage({
        data: clientSpecificBorderLineBase64,
        x: 0,
        y: 3.9,
        w: "100%",
        h: 1,
      });
      let clientStmnt =
        "This proposal is tailored specifically to meet the campaign requirements of";
      let clientNamePPT = effectiveClientName;
      clientSlide.addText(clientStmnt, {
        x: 2.1,
        y: 3,
        w: 6,
        h: 1,
        fontSize: 21,
        // bold: true,
        wrap: true,
        color: "FFFFFF",
        align: pptx.AlignH.center,
      });
      clientSlide.addText(clientNamePPT, {
        x: 1.8,
        y: 4.5,
        w: 6,
        fontSize: 40,
        bold: true,
        wrap: true,
        color: "FFFFFF",
        align: pptx.AlignH.center,
      });

      let textVal;

      for (const data of proposalInventories) {
        console.log("jnjb", data);
        const corsProxyUrl = "https://cors-anywhere.herokuapp.com/";
        const slide = pptx.addSlide();
        slide.background = { data: welcomeBackgroundBase64, opacity: 50 };
        slide.addImage({
          data: svg1Base64,
          x: "90%",
          y: -0.3,
          w: 1.3,
          h: 1.3,
        });
        // // Convert image URL to base64
        // const corsProxyUrl = "https://cors-anywhere.herokuapp.com/";
        const options = {
          x: 0.2,
          y: 0.3,
          w: 6.1,
          h: "90%",
        };
        const imgSlideMain = await fetchImageAsBase64(data?.img);
        slide.addImage({ data: imgSlideMain, ...options });

        const textX = 6.1;
        let textY = 1.8;
        const lineHeight = 0.7;

        slide.addImage({
          data: hoardingIconBase64,
          x: textX + 0.3,
          y: textY,
          w: 0.2,
          h: 0.3,
        });
        textVal = `${data.width} X ${data.height} ${data?.Illu ?? ""} ${data.mediaVehicle
          }`;
        slide.addText(textVal, {
          x: textX + 0.6,
          y: textY + 0.15,
          w: 3.1,
          fontSize: 15,
          fontFace: "Montserrat Medium",
          // bold: true,
          wrap: true,
          color: "FFFFFF",
        });
        textY += lineHeight; // Increment Y-coordinate for the next text item

        slide.addImage({
          data: locationIconBase64,
          x: textX + 0.3,
          y: textY,
          w: 0.2,
          h: 0.3,
        });
        textVal = `${data.location} `;
        slide.addText(textVal, {
          x: textX + 0.6,
          y: textY + 0.15,
          w: 3.1,
          fontSize: 15,
          fontFace: "Montserrat Medium",
          // bold: true,
          wrap: true,
          color: "FFFFFF",
        });
        textY += lineHeight; // Increment Y-coordinate for the next text item

        // textVal = `SITE : ${data.area}`
        // slide.addText(textVal, {
        //     x: textX,
        //     y: textY,
        //     w: 4,
        //     font_size: 18,
        //     bold: true,
        //     wrap: true
        // });
        // textY += lineHeight; // Increment Y-coordinate for the next text item

        // textVal = `Printing Charge: ${data.printingCharge} Rs`
        // slide.addText(textVal, {
        //     x: textX,
        //     y: textY,
        //     w: 4,
        //     font_size: 18,
        //     bold: true,
        //     wrap: true
        // });
        // textY += lineHeight; // Increment Y-coordinate for the next text item

        // textVal = `Mounting Charge: ${data.mountingCharge} Rs`
        // slide.addText(textVal, {
        //     x: textX,
        //     y: textY,
        //     w: 4,
        //     font_size: 18,
        //     bold: true,
        //     wrap: true
        // });
        // textY += lineHeight; // Increment Y-coordinate for the next text item
        if (!packageRate && !hasSpecialRateChanged) {
          slide.addImage({
            data: rupeeIconBase64,
            x: textX + 0.3,
            y: textY,
            w: 0.2,
            h: 0.3,
          });
          textVal = `${data.ratePerMonth} /- PM`;
          slide.addText(textVal, {
            x: textX + 0.6,
            y: textY + 0.15,
            w: 3.1,
            fontSize: 15,
            fontFace: "Montserrat Medium",
            // bold: true,
            wrap: true,
            color: "FFFFFF",
          });
          textY += lineHeight; // Increment Y-coordinate for the next text item
        }
        if (new RegExp(data?.mediaVehicle, "i").test("kiosk")) {
          slide.addImage({
            data: unitsIconBase64,
            x: textX + 0.3,
            y: textY,
            w: 0.3,
            h: 0.3,
          });
          textVal = `${data?.unit} units`;
          slide.addText(textVal, {
            x: textX + 0.6,
            y: textY + 0.15,
            w: 3.1,
            fontSize: 15,
            fontFace: "Montserrat Medium",
            // bold: true,
            wrap: true,
            color: "FFFFFF",
          });
          textY += lineHeight;
        }

        slide.addImage({
          data: calendarIconBase64,
          x: textX + 0.3,
          y: textY,
          w: 0.2,
          h: 0.3,
        });
        textVal = `Available From - ${getProposalAvailableFromLabel(data)}`;
        slide.addText(textVal, {
          x: textX + 0.6,
          y: textY + 0.15,
          w: 3.1,
          fontSize: 15,
          fontFace: "Montserrat Medium",
          // bold: true,
          wrap: true,
          color: "FFFFFF",
        });
        textY += lineHeight;
        // slide.addShape(pptx.ShapeType.rect, {
        //   x: 0,
        //   y: "98.5%",
        //   w: "90%",
        //   h: 0.09,
        //   fill: "FFFF00",
        // });

        // Add dummy logo at bottom right corner
        slide.addImage({
          data: pptSliderCornerLogoBase64,
          x: "80%",
          y: "88%",
          w: 2,
          h: 0.7,
        });
      }

      const contactInfo = pptx.addSlide();
      contactInfo.background = { data: welcomeBackgroundBase64, opacity: 50 };

      contactInfo.addImage({
        data: contactRightImageBase64,
        x: "50%",
        y: 0,
        w: 5,
        h: "100%",
      });
      contactInfo.addImage({
        data: contactUsTitleBase64,
        x: 0.2,
        y: 0.4,
        w: 5,
        h: 1.6,
      });
      //rightTopcorner
      contactInfo.addImage({
        data: svg1Base64,
        x: "90%",
        y: -0.3,
        w: 1.3,
        h: 1.3,
      });
      contactInfo.addImage({
        data: contactDetailsBase64,
        x: 0.2,
        y: 2.0,
        w: 4.8,
        h: 3,
      });

      //🤡🤡 Thank you Slide
      const ThankYouSlide = pptx.addSlide();
      ThankYouSlide.background = { data: welcomeBackgroundBase64, opacity: 50 };
      // ThankYouSlide.background = {
      //   path: "/images/pptSlideLast.jpg",
      //   opacity: 50,
      // };
      ThankYouSlide.addImage({
        data: pptSlideLastBase64,
        x: 1,
        y: "23%",
        w: 9,
        h: "48%",
      });

      ThankYouSlide.addImage({
        data: thankYouImageBase64,
        x: "46%",
        y: "40%",
        w: 3,
        h: 0.7,
        // fontSize: 63, // Increase the font size to make it bigger,
        // fontFace:"Arial",
        // bold: true,
        // color: "FFFFFF", // Set the color to white (hex code)
        // wrap: true,
      });

      await pptx.writeFile({
        fileName: `${effectiveClientName} Proposal_${moment().format(
          "YYYY-MM-DD",
        )}.pptx`,
      });
      setShowLoader(false);
    } catch (err) {
      notification.error({ message: err.message });
      setShowLoader(false);
    }
    // Generate the presentation file as a Blob
    pptx.write("blob").then(async (blob) => {
      const fileName = `${effectiveClientName} Proposal_${moment().format(
        "YYYY-MM-DD",
      )}.pptx`;
      const mime =
        "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      const token = window.localStorage.getItem("token");

      const requestBody = {
        fileName,
        mime: mime,
        "Content-Type": mime,
      };

      try {
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/uploadPolicyForEmails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${token}`,
            },
            body: JSON.stringify(requestBody),
          },
        );

        if (!response.ok) {
          console.error(`HTTP error! Status: ${response.status}`);
          return;
        }

        const data = await response.json();

        if (!data?.data?.fields || !data?.data?.url) {
          return;
        }

        const formData = new FormData();

        // Ensure Content-Type matches S3 policy (same as AddInventoryContainer)
        const expectedContentType = mime;

        Object.entries(data.data.fields).forEach(([key, value]) => {
          if (
            key.toLowerCase() === "content-type" ||
            key.toLowerCase() === "mime"
          ) {
            formData.append(key, expectedContentType);
          } else {
            formData.append(key, value);
          }
        });

        if (
          !formData.has("Content-Type") &&
          !formData.has("content-type") &&
          !formData.has("mime")
        ) {
          formData.append("Content-Type", expectedContentType);
        }

        const file = new File([blob], fileName, { type: mime });
        formData.append("file", file);

        try {
          const almostFinalResponse = await fetch(data.data.url, {
            method: "POST",
            body: formData,
          });

          if (almostFinalResponse.ok) {
            const key = data.data.fields?.key ?? data.filePath;
            finalurlPpt = convertS3ToCloudFront(`${data.data.url}/${key}`);
            setFinalUrl1(finalurlPpt);
            console.log("PPT uploaded successfully:", finalurlPpt);
          } else {
            console.error(
              "PPT upload failed:",
              almostFinalResponse.status,
              almostFinalResponse.statusText,
            );
          }
        } catch (error) {
          console.error("PPT upload error:", error);
        }
      } catch (error) {
        console.error("Error fetching upload policy:", error);
      }
    });
  }
  async function generateProposal() {
    let data;
    let flag = false;
    if (proposalInventories.length > 0) {
      const effectiveClient =
        clientName && (clientName.value != null || clientName.label)
          ? clientName
          : inputValue?.trim()
            ? { value: null, label: inputValue.trim() }
            : null;

      if (!effectiveClient || !effectiveClient.label) {
        notification.error({ message: "Client Name is to be entered" });
        return;
      }

      data = proposalInventories.map((ele) => {
        let discount = discountCalc(ele.specialRate, ele.ratePerMonth);
        if (!activatePR) {
          if (discount > 20) {
            flag = true;
          }
        }
        return {
          invId: ele._id,
          printingCharge: activatePR ? 0 : ele.printingCharge,
          mountingCharge: activatePR ? 0 : ele.mountingCharge,
          // rpm: ele.isTrading ? 0 : ele.ratePerMonth, 🎉🎉
          rpm: ele.ratePerMonth,
          specialRate: activatePR ? 0 : ele.specialRate,
          innovationRate: activatePR ? 0 : ele.innovationRate,
          discount: activatePR ? 0 : discount,
        };
      });
      const postData = {
        clientId: effectiveClient.value ?? null,
        clientName: effectiveClient.label ?? null,
        proposalInvs: data, // Assuming proposalInvs is an array of invoice names
        packageRate: activatePR ? packageRate : null,
      };

      console.log("Post Data: ", postData);

      try {
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/generateProposal`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include", // Include credentials such as cookies
            body: JSON.stringify(postData),
          },
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        setProposalId(data?.id);
        propId = data?.id;
        setEmailSrNo(data?.lastStamp + 1);
        setClientId(data?.clientId);
        setShowLoader(true);

        // 🎈🎈🎈
        if (!flag || data?.Elite) {
          await handleDownloadExcel();
        }
        // 🎈🎈🎈

        setShowLoader(false);
        // console.log("Proposal generated successfully:", data);
        // console.log("This is the final urkl", finalUrl1);
        // console.log("This is the final urkl", finalUrl2);

        !flag || data?.Elite
          ? notification.success({
            message: "The proposals has been Generated!",
          })
          : notification.success({
            message:
              "The proposals has been Generated and sent for Approval!",
          });

        dispatch(resetCart());
        handleReset();
      } catch (error) {
        console.error("Error generating proposal:", error);
      }
    }
  }

  async function generateBDF() {
    if (proposalInventories?.length > 0) {
      let data = {
        // GST: GSTNumber,
        packageRate,
        invs: proposalInventories,
      };
      dispatch(addProposalInventories(data));
      dispatch(emptyDraft());
      handleReset();
      navigate(`/clients-bdf/direct-bdf`);
    } else {
      notification.error({
        message: "Enter all the required fields for BDF generation",
      });
    }
  }
  function applyDisCountToAll() {
    setApplyPer((prev) => !prev);
  }
  // // helps you select view the selected records in the modal
  // useEffect(() => {
  //     if (inventories?.length > 0 && bookingModalOpen) {
  //         let info = [];
  //         console.log(invnet)
  //         inventories.forEach(item => {
  //             if (checkedRecords[item._id]) {
  //                 info.push(
  //                     {
  //                         _id: item._id,
  //                         CodeNo: item.CodeNo,
  //                         typeOfMedia: item?.typeOfMedia?.name,
  //                         Availability: item.Availability,
  //                     }
  //                 )
  //             }
  //         })
  //         setProposalInventories(info)
  //     }
  // }, [isModalOpen])
  //Proposal Modal
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    if (bookingModalOpen) {
      setBookingModalOpen(false);
      dispatch(emptyProposalInventories());
    }
    setProposalInventories(null);
    setFinalUrl1(null);
    setFinalUrl2(null);
    // finalurlExcel = "";
    // finalurlPpt = "";
    // propId = "";
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setInputLabel("");
    setInputValue("");
    if (bookingModalOpen) {
      setBookingModalOpen(false);
      dispatch(emptyProposalInventories());
    }
    setProposalInventories(null);
    setFinalUrl1(null);
    setFinalUrl2(null);
    finalurlExcel = "";
    finalurlPpt = "";
    propId = "";
  };

  //Booking Modal
  const showBookingModal = () => {
    setBookingModalOpen(true);
  };

  const handleBookingOk = () => {
    setBookingModalOpen(false);
    setInputLabel("");
    setInputValue("");
  };
  const handleBooking = (record) => {
    setBookingModalOpen(true);
  };
  const handleBookingModalCancel = () => {
    setClientName(null);
    setBookingModalOpen(false);
    setInputLabel("");
    setInputValue("");
  };
  const customTitle = (
    <div className="custom-modal-title-prop">
      <h2>Inventory Proposal</h2>
      {/* <Switch
          checkedChildren="REMOVE 20% FROM ALL"
          unCheckedChildren="APPLY 20% TO ALL"
          defaultChecked={applyPer} // Set the default checked status based on state
          onChange={applyDisCountToAll} // Handle the onChange event
        /> */}
    </div>
  );

  const columns =
    bookingsOpen || proposalsOpen || blockingOpen
      ? [
        {
          title: "Id",
          dataIndex: "_id",
          key: "_id",
        },
        {
          title: bookingsOpen ? "Bookings" : proposalsOpen && "Proposals",
          dataIndex: "bookings",
          key: "bookings",
          render: (_, rowData) => (
            <Checkbox
              onChange={(e) => handleCheckboxChange(e, rowData)}
              checked={checkedRecords[rowData._id]}
            />
          ),
        },
        {
          title: "Inventory Code No.",
          dataIndex: "CodeNo",
          key: "CodeNo",
        },
        {
          title: "Media Vehicle",
          dataIndex: "typeOfMedia",
          key: "typeOfMedia",
        },
        {
          title: "Width (ft)",
          dataIndex: "width",
          key: "width",
        },
        {
          title: "Height (ft)",
          dataIndex: "height",
          key: "height",
        },
        {
          title: "Area",
          dataIndex: "Area",
          key: "Area",
        },
        {
          title: "Availability",
          dataIndex: "Availability",
          key: "Availability",
        },
        {
          title: "Units",
          dataIndex: "unit",
          key: "unit",
        },
        {
          title: "Details",
          dataIndex: "details",
          key: "details",
          render: (_, rowData) => (
            <TableButtonComponent
              buttonColor="#026E78"
              data="View"
              handleClick={() => handleInventoryView(rowData._id)}
            />
          ),
        },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",

          render: (_, rowData) => (
            <div
              className="inventory-cart-actions"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <div
                onClick={() => {
                  dispatch(removeFromCart(rowData.Area));
                  let data = dataSourceB?.filter(
                    (ele) => ele.Area != rowData.Area,
                  );
                  setDataSource(data);
                  setDataSourceB(data);
                }}
              >
                <MdDelete size={20} color={"#D96E6E"} />
              </div>
            </div>
          ),
        },
      ]
      : [
        {
          title: "Id",
          dataIndex: "_id",
          key: "_id",
        },
        {
          title: "Inventory Code No.",
          dataIndex: "CodeNo",
          key: "CodeNo",
        },
        {
          title: "Media Vehicle",
          dataIndex: "typeOfMedia",
          key: "typeOfMedia",
        },
        {
          title: "Width (ft)",
          dataIndex: "width",
          key: "width",
        },
        {
          title: "Height (ft)",
          dataIndex: "height",
          key: "height",
        },
        {
          title: "Area",
          dataIndex: "Area",
          key: "Area",
        },
        {
          title: "Availability",
          dataIndex: "Availability",
          key: "Availability",
        },
        {
          title: "Units",
          dataIndex: "unit",
          key: "unit",
        },
        {
          title: "Details",
          dataIndex: "details",
          key: "details",

          render: (_, rowData) => (
            <TableButtonComponent
              buttonColor="#026E78"
              data="View"
              handleClick={() => handleInventoryView(rowData._id)}
            />
          ),
        },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",

          render: (_, rowData) => (
            <div
              className="inventory-cart-actions"
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
              }}
            >
              <div
                onClick={() => {
                  dispatch(removeFromCart(rowData.Area));
                  let data = dataSourceB?.filter(
                    (ele) => ele.Area != rowData.Area,
                  );
                  setDataSource(data);
                  setDataSourceB(data);
                }}
              >
                <MdDelete size={20} color={"#D96E6E"} />
              </div>
            </div>
          ),
        },
      ];

  const columnsForBookings = [
    {
      title: "_id",
      dataIndex: "_id",
      key: "_id",
    },
    {
      title: "Inventory Code No.",
      dataIndex: "CodeNo",
      key: "CodeNo",
    },
    {
      title: "Display Name",
      dataIndex: "display",
      render: (_, record) => (
        <Input
          value={record.display}
          onChange={(e) => handleDisplayChange(e.target.value, record._id)}
        />
      ),
    },
    {
      title: "Date Range",
      dataIndex: "range",
      render: (_, record) => (
        <RangePicker
          value={record.range}
          onChange={(dates) => handleRangeChange(dates, record._id)}
        />
      ),
    },
    {
      title: "Rate per Month",
      dataIndex: "rate",
      render: (_, record) => (
        <Input
          value={record.rate}
          onChange={(e) =>
            handleRateChange(parseFloat(e.target.value), record._id)
          }
        />
      ),
    },
  ];

  // Handler function to update the date range in bookInventories
  const handleRangeChange = (dates, key) => {
    const startDate = moment(new Date(dates[0])).format();
    const endDate = moment(new Date(dates[1])).format();
    const ind = bookInventories.findIndex((ele) => ele._id == key);
    if (ind != -1) {
      setBookInventories((prev) => {
        let arr = [...prev];
        arr[ind].startDate = startDate;
        arr[ind].endDate = endDate;
        return arr;
      });
    }
  };

  // Handler function to update the rate in bookInventories

  const handleRateChange = (value, key) => {
    setBookInventories((prev) => {
      return prev.map((item) => {
        if (!Number(value) && item._id === key) {
          return { ...item, rate: "" };
        } else if (item._id === key) {
          return { ...item, rate: Number(value) };
        }
        return item;
      });
    });
  };

  //Handler function to update the display in bookInventories
  const handleDisplayChange = (value, key) => {
    const ind = bookInventories.findIndex((ele) => ele._id == key);
    if (ind != -1) {
      setBookInventories((prev) => {
        let arr = [...prev];
        arr[ind].display = value;
        return arr;
      });
    }
  };

  const [MVFiltering, setMVFiltering] = useState([]);
  const handleMVFiltering = (selectedValues) => {
    setMVFiltering(selectedValues);
    if (selectedValues?.length > 0 && dataSourceB?.length > 0) {
      let filteredInventories = dataSourceB.filter((ele) =>
        selectedValues.includes(ele.typeOfMedia),
      );
      setDataSource(filteredInventories);
    } else {
      setDataSource(dataSourceB);
    }
  };
  const handleClickBookings = () => {
    setBookingsOpen((prev) => !prev);
    if (proposalsOpen || blockingOpen) {
      setProposalsOpen(false);
      setBlockingOpen(false);
    }
    setCheckedRecords({});
    handleSelectAll();
  };

  const handleBookSuffix = () => {
    dispatch(emptyProposalInventories());
    navigate("/clients-bdf/direct-bdf?suffix");
  };

  const handleCancelBlockingModal = () => {
    setBlockingModalOpen(false);
    setBlockingSubmitLoading(false);
    setInputLabel("");
    setInputValue("");
  };
  const handleBlockInventoriesInitiation = () => {
    setBlockingOpen((prev) => !prev);
    if (proposalsOpen || bookingsOpen) {
      setProposalsOpen(false);
      setBookingsOpen(false);
    }
    setCheckedRecords({});
    handleSelectAll();
  };
  const handleReset = () => {
    // dispatch(resetCart());
    setDataSource(null);
    setDataSourceB(null);
    setCheckedRecords({});
  };
  const handleBlockInventories = async () => {
    if (blockingType == "premium" && clientName && blockInvWhole.length > 0) {
      if (!clientName || !confirmedBy) {
        notification.error({
          message: `Please fill in all the necessary fields.`,
        });
        return;
      }
      let data = {
        blockedForId: clientName.value,
        blockedForName: clientName.label,
        inventories: blockInvWhole,
        confirmedBy: confirmedBy,
      };
      dispatch(emptyBlockInventories());
      dispatch(addBlockInventories(data));
      navigate("/premiumBlock/create");
      return;
    } else if (
      clientName &&
      confirmedBy &&
      campaignName &&
      blockedInventories.length > 0 &&
      blockingType !== "premium"
    ) {
      if (
        (blockingType === "premium" || blockingType === "management") &&
        (!startDate || !endDate)
      ) {
        notification.error({
          message: `Please select start and end dates for ${blockingType} Blocking.`,
        });
        return;
      }
      setBlockingSubmitLoading(true);
      try {
        let data = await blockInventoriesApi(
          blockedInventories,
          blockingType,
          startDate,
          endDate,
          confirmedBy,
          campaignName,
        );
        if (data.success) {
          notification.success({ message: data.message });
          setBlockingModalOpen(false);
          dispatch(resetCart());
          handleReset();
          navigate("/blocked");
        } else {
          notification.error({ message: data.message });
        }
      } finally {
        setBlockingSubmitLoading(false);
      }
    } else {
      notification.error({
        message: "Fill in all the necessary fields to Block",
      });
    }
  };

  async function blockInventoriesApi(
    blockedInventories,
    blockingType,
    startDate,
    endDate,
    confirmedBy,
    campaignName,
  ) {
    let requestBody = {
      invIds: blockedInventories,
      premiumBlock: blockingType === "premium",
      managementBlock: blockingType === "management",
      blockedAt: startDate,
      blockedTill: endDate,
      confirmedBy,
      campaignName: (campaignName || "").toUpperCase(),
    };

    if (clientName?.value) {
      requestBody.blockedFor = clientName.value;
    } else {
      const partyName = (clientName?.label ?? "").trim().toUpperCase();
      if (partyName) requestBody.partyName = partyName;
    }
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/blockInventories`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );
      return response.json();
    } catch (err) {
      console.error("Error : ", err.message);
      return { success: false, message: err.message };
    }
  }

  const handleSelectAll = () => {
    cart.length > 0 &&
      cart.forEach((ele) => {
        setCheckedRecords((prev) => ({
          ...prev,
          [ele._id]: true,
        }));
      });
  };
  const handleDeSelectAll = () => {
    cart.length > 0 &&
      cart.forEach((ele) => {
        setCheckedRecords((prev) => ({
          ...prev,
          [ele._id]: false,
        }));
      });
  };
  const handleClickProposals = () => {
    setProposalsOpen((prev) => !prev);
    if (bookingsOpen || blockingOpen) {
      setBookingsOpen(false);
      setBlockingOpen(false);
    }
    setCheckedRecords({});
    handleSelectAll();
  };
  //This handles the 4 input values inside the Proposal Modal
  // const handleSelectChange = (id) => (value) => {
  //     switch (value) {
  //         case 'Back Lit':
  //             setProposalInventories(prev => {
  //                 return prev.map(item => {
  //                     if (item._id === id) {
  //                         // Check if the value is a valid number or empty
  //                         let sqft = item.width * item.height;
  //                         let charge = sqft * 20
  //                         const newValue = charge === "" || !isNaN(parseFloat(charge)) ? Number(charge) : "";
  //                         return { ...item, printingCharge: newValue };
  //                     }
  //                     return item;
  //                 });
  //             });
  //             break;
  //         case 'Front Lit & Nonlit (Normal Flex)':
  //             setProposalInventories(prev => {
  //                 return prev.map(item => {
  //                     if (item._id === id) {
  //                         // Check if the value is a valid number or empty
  //                         let sqft = item.width * item.height;
  //                         let charge = sqft * 10
  //                         const newValue = charge === "" || !isNaN(parseFloat(charge)) ? Number(charge) : "";
  //                         return { ...item, printingCharge: newValue };
  //                     }
  //                     return item;
  //                 });
  //             });
  //             break;
  //         case 'Front Lit & Nonlit (Black Back)':
  //             setProposalInventories(prev => {
  //                 return prev.map(item => {
  //                     if (item._id === id) {
  //                         // Check if the value is a valid number or empty
  //                         let sqft = item.width * item.height;
  //                         let charge = sqft * 12
  //                         const newValue = charge === "" || !isNaN(parseFloat(charge)) ? Number(charge) : "";
  //                         return { ...item, printingCharge: newValue };
  //                     }
  //                     return item;
  //                 });
  //             });
  //             break;
  //         case 'Back Lit (Start Flex)':
  //             setProposalInventories(prev => {
  //                 return prev.map(item => {
  //                     if (item._id === id) {
  //                         // Check if the value is a valid number or empty
  //                         let sqft = item.width * item.height;
  //                         let charge = sqft * 25
  //                         const newValue = charge === "" || !isNaN(parseFloat(charge)) ? Number(charge) : "";
  //                         return { ...item, printingCharge: newValue };
  //                     }
  //                     return item;
  //                 });
  //             });;
  //             break;
  //         default:
  //             // Do nothing
  //             break;
  //     }
  // };
  const handlePrintingCharge = (id) => (e) => {
    const value = e.target.value;
    setProposalInventories((prev) => {
      return prev.map((item) => {
        if (item._id === id) {
          // Check if the value is a valid number or empty
          const newValue =
            value === "" || !isNaN(parseFloat(value)) ? Number(value) : 0;
          return { ...item, printingCharge: newValue };
        }
        return item;
      });
    });
  };
  const handlePCIncrement = (id) => (e) => {
    setProposalInventories((prev) => {
      return prev.map((item) => {
        if (item._id === id) {
          // Ensure that the printingCharge is a valid number or empty
          const currentValue =
            parseFloat(item.printingCharge) === 0
              ? 1
              : parseFloat(item.printingCharge);
          const newValue = isNaN(currentValue)
            ? ""
            : Math.floor(Math.min(currentValue * 2, Infinity));
          return { ...item, printingCharge: newValue };
        }
        return item;
      });
    });
  };

  const handlePCDecrement = (id) => (e) => {
    setProposalInventories((prev) => {
      return prev.map((item) => {
        if (item._id === id) {
          // Ensure that the printingCharge is a valid number or empty
          const currentValue =
            parseFloat(item.printingCharge) === 0
              ? 1
              : parseFloat(item.printingCharge);
          const newValue = isNaN(currentValue)
            ? ""
            : Math.floor(Math.max(currentValue / 2, 0));
          return { ...item, printingCharge: newValue };
        }
        return item;
      });
    });
  };

  const handleMountingCharge = (id) => (e) => {
    setProposalInventories((prev) => {
      return prev.map((item) => {
        if (!Number(e.target.value) && item._id === id) {
          return { ...item, mountingCharge: 0 };
        } else if (item._id === id) {
          return { ...item, mountingCharge: Number(e.target.value) };
        }
        return item;
      });
    });
  };
  const handleInnovationRate = (id) => (e) => {
    setProposalInventories((prev) => {
      return prev.map((item) => {
        if (!Number(e.target.value) && item._id === id) {
          return { ...item, innovationRate: 0 };
        } else if (item._id === id) {
          return { ...item, innovationRate: Number(e.target.value) };
        }
        return item;
      });
    });
  };

  const handleMCIncrement = (id) => (e) => {
    setProposalInventories((prev) => {
      return prev.map((item) => {
        if (item._id === id) {
          // Ensure that the printingCharge is a valid number or empty
          const currentValue =
            parseFloat(item.mountingCharge) === 0
              ? 1
              : parseFloat(item.mountingCharge);
          const newValue = isNaN(currentValue)
            ? ""
            : Math.floor(Math.min(currentValue * 2, Infinity));
          return { ...item, mountingCharge: newValue };
        }
        return item;
      });
    });
  };

  const handleMCDecrement = (id) => (e) => {
    setProposalInventories((prev) => {
      return prev.map((item) => {
        if (item._id === id) {
          // Ensure that the printingCharge is a valid number or empty
          const currentValue =
            parseFloat(item.mountingCharge) === 0
              ? 1
              : parseFloat(item.mountingCharge);
          const newValue = isNaN(currentValue)
            ? ""
            : Math.floor(Math.max(currentValue / 2, 0));
          return { ...item, mountingCharge: newValue };
        }
        return item;
      });
    });
  };
  const [bulkUploadFlag, setBulkUploadFlag] = useState(false);
  const [arrOfMediaUrls, setArrOfMediaUrls] = useState([]);
  const handleFileSelectOfPrevieww = async (event) => {
    const files = event.target.files;
    if (!files) {
      console.error("No files selected.");
      return;
    }
    setBulkUploadFlag(false);
    setArrOfMediaUrls([]);
    let links = [];
    for (const file of files) {
      const fileType = file.type;
      const requestBody = {
        fileName: encodeURIComponent(file.name),
        mime: fileType,
        "Content-Type": fileType,
      };

      try {
        const response = await fetch(
          `${apiBaseUrl}/inventoryManagement/uploadPolicyForEmails`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `Token ${window.localStorage.getItem("token")}`,
            },
            body: JSON.stringify(requestBody),
          },
        );

        const data = await response.json();

        if (!data?.data?.fields || !data?.data?.url) {
          continue;
        }

        const formData = new FormData();

        // Ensure Content-Type matches S3 policy (same as AddInventoryContainer)
        const expectedContentType = fileType || "image/jpeg";

        Object.entries(data.data.fields).forEach(([key, value]) => {
          if (
            key.toLowerCase() === "content-type" ||
            key.toLowerCase() === "mime"
          ) {
            formData.append(key, expectedContentType);
          } else {
            formData.append(key, value);
          }
        });

        if (
          !formData.has("Content-Type") &&
          !formData.has("content-type") &&
          !formData.has("mime")
        ) {
          formData.append("Content-Type", expectedContentType);
        }

        formData.append("file", file);

        try {
          const almostFinalResponse = await fetch(data.data.url, {
            method: "POST",
            body: formData,
          });

          if (almostFinalResponse.ok) {
            const key = data.data.fields?.key ?? data.filePath;
            const finalurl = convertS3ToCloudFront(
            `${data.data.url}/${encodeURIComponent(key)}`,
          );
            links.push(finalurl);
            console.log("File uploaded successfully:", finalurl);
          } else {
            console.log(
              "Error occurred:",
              almostFinalResponse.status,
              almostFinalResponse.statusText,
            );
          }
        } catch (error) {
          console.log("Error occurred:", error);
        }
      } catch (error) {
        console.error("Error fetching upload policy:", error);
      }
    }
    setArrOfMediaUrls(links);
    setBulkUploadFlag(true);
  };

  const uploadFile = async (file) => {
    try {
      const fileType = file.type;
      const requestBody = {
        fileName: encodeURIComponent(file.name),
        mime: fileType,
        "Content-Type": fileType,
        acl: "public-read",
      };
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/uploadPolicy`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      if (!response.ok) {
        throw new Error("Unable to create policy");
      }

      const data = await response.json();

      if (!data?.data?.fields || !data?.data?.url) {
        return;
      }

      const formData = new FormData();
      const expectedContentType = fileType || "image/jpeg";

      Object.entries(data.data.fields).forEach(([key, value]) => {
        if (
          key.toLowerCase() === "content-type" ||
          key.toLowerCase() === "mime"
        ) {
          formData.append(key, expectedContentType);
        } else {
          formData.append(key, value);
        }
      });

      if (
        !formData.has("Content-Type") &&
        !formData.has("content-type") &&
        !formData.has("mime")
      ) {
        formData.append("Content-Type", expectedContentType);
      }

      formData.append("file", file);

      const uploadResponse = await fetch(data.data.url, {
        method: "POST",
        body: formData,
      });

      if (uploadResponse.ok) {
        const key = data.data.fields?.key ?? data.filePath;
        const finalUrl = convertS3ToCloudFront(
          `${data.data.url}/${encodeURIComponent(key)}`,
        );
        console.log("File uploaded successfully:", finalUrl);
      } else {
        console.error("Upload failed:", uploadResponse.status, uploadResponse.statusText);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const handleFileChange2 = (event) => {
    const file = event.target.files[0];
    if (file) {
      uploadFile(file);
    }
  };

  const handleSpecialRate = (id) => (e) => {
    setProposalInventories((prev) => {
      return prev.map((item) => {
        if (!Number(e.target.value) && item._id === id) {
          return { ...item, specialRate: 0, specialRatePerMonth: 0 };
        } else if (item._id === id) {
          const nextVal = Number(e.target.value);
          // Keep both fields in sync:
          // - Inventory modal calls this "Special Rate Per Month"
          // - BDF Detail Type 3 uses `specialRatePerMonth`
          return {
            ...item,
            specialRate: nextVal,
            specialRatePerMonth: nextVal,
          };
        }
        return item;
      });
    });
  };
  //This handles the 4 input values inside the Proposal Modal

  const handleInventoryView = (key) => {
    const ind = inventories.findIndex((ele) => ele._id == key);
    if (ind != -1) {
      setSelectedInventory(inventories[ind]);
      setInventoryView(true);
    }
  };
  const userId = useSelector((state) => state.user._id);

  // const handleDownloadExcel = () => {
  //     saveAs(OOHProposalChitraB, 'OOH Proposal - Chitra B.xlsx');
  // };

  //Downloading different File Types

  // const handleDownloadExcel = async () => {
  //   let flag = false;
  //   const xlsData = [];
  //   xlsData.push(["To"]);
  //   xlsData.push(["Client", clientName.label]);
  //   xlsData.push(["Date", moment().format("DD-MM-YYYY")]);
  //   xlsData.push([]);
  //   xlsData.push([
  //     "Sr.No",
  //     "Location",
  //     "Media Vehicle",
  //     "Size (W)",
  //     "Size (H)",
  //     "Media Type",
  //     "Rate Per Month",
  //     "Special Rate",
  //     "Printing Charges",
  //     "Mounting Charges",
  //     "Available From",
  //   ]);
  //   proposalInventories.forEach((ele, ind) => {
  //     if (
  //       ele.printingCharge == null ||
  //       ele.mountingCharge == null ||
  //       ele.specialRate == null ||
  //       clientName.label == null ||
  //       clientName.label === ""
  //     ) {
  //       flag = true;
  //       return;
  //     }

  //     let data = dateAvailability(ele.Bookings);
  //     let Availability =
  //       data.status == "IMMEDIATE"
  //         ? "IMMEDIATE"
  //         : moment(data.nextAvailableDate).format("DD-MM-YYYY");
  //     xlsData.push([
  //       String(ind + 1) || "-",
  //       ele.location || "-",
  //       ele.mediaVehicle || "-",
  //       String(ele.width) || "-",
  //       String(ele.height) || "-",
  //       ele.Illu || "-",
  //       String(ele.ratePerMonth) || "-",
  //       String(ele.specialRate) || "-",
  //       String(ele.printingCharge) || "-",
  //       String(ele.mountingCharge) || "-",
  //       Availability || "-",
  //     ]);
  //   });
  //   if (flag) {
  //     notification.error({
  //       message: "Enter all the required info before generating an excel",
  //     });
  //     return;
  //   }
  //   xlsData.push([]);
  //   xlsData.push([]);
  //   xlsData.push(["* Tax Extra as Applicable"]);
  //   xlsData.push(["Thanks & regards,"]);
  //   xlsData.push(["YELLOW SPOT OOH"]);
  //   // Create a worksheet
  //   const ws = XLSX.utils.aoa_to_sheet(xlsData);

  //   // Center align the content in each cell
  //   const range = XLSX.utils.decode_range(ws["!ref"]);
  //   for (let R = range.s.r; R <= range.e.r; ++R) {
  //     for (let C = range.s.c; C <= range.e.c; ++C) {
  //       const cellAddress = { c: C, r: R };
  //       const cellRef = XLSX.utils.encode_cell(cellAddress);
  //       const cell = ws[cellRef];
  //       if (cell && cell.v && !cell.s) {
  //         cell.s = {}; // Ensure cell style exists
  //       }
  //       if (cell && cell.s) {
  //         cell.s.alignment = { horizontal: "center", vertical: "center" }; // Set alignment to center
  //         // Set border styles
  //         cell.s.border = {
  //           top: { style: "thin", color: { auto: 1 } },
  //           bottom: { style: "thin", color: { auto: 1 } },
  //           left: { style: "thin", color: { auto: 1 } },
  //           right: { style: "thin", color: { auto: 1 } },
  //         };
  //       }
  //     }
  //   }

  //   // Adjust column widths
  //   for (let C = range.s.c; C <= range.e.c; ++C) {
  //     let maxWidth = 0;
  //     for (let R = range.s.r; R <= range.e.r; ++R) {
  //       const cellAddress = { c: C, r: R };
  //       const cellRef = XLSX.utils.encode_cell(cellAddress);
  //       const cell = ws[cellRef];
  //       if (cell && cell.v) {
  //         const cellTextWidth = cell.v.toString().length;
  //         maxWidth = Math.max(maxWidth, cellTextWidth);
  //       }
  //     }
  //     ws["!cols"] = ws["!cols"] || [];
  //     ws["!cols"][C] = { wch: maxWidth + 2 }; // Adding extra padding
  //   }

  //   // Create a workbook and append the worksheet
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Students");

  //   // Convert the workbook to a binary string
  //   const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

  //   saveAs(
  //     new Blob([s2ab(wbout)], { type: "application/octet-stream" }),
  //     fileName
  //   );
  //   // Convert the binary string to a Blob
  //   const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });

  // Prepare request details
  const getExcelColumnLetter = (colNumber) => {
    // changed
    let letter = ""; // changed
    while (colNumber > 0) {
      // changed
      const temp = (colNumber - 1) % 26; // changed
      letter = String.fromCharCode(65 + temp) + letter; // changed
      colNumber = Math.floor((colNumber - temp - 1) / 26); // changed
    } // changed
    return letter; // changed
  }; // changed

  const normalizeHeader = (s) =>
    String(s || "")
      .replace(/\s+/g, " ")
      .trim(); // changed

  const formatIndianAllNumbers = (val) => {
    // changed
    if (val === null || val === undefined) return val; // changed
    if (typeof val !== "number" || !Number.isFinite(val)) return val; // changed
    try {
      // changed
      return String(formatIndianNumber(val)); // changed
    } catch {
      // changed
      return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: 6,
      }).format(val); // changed
    } // changed
  }; // changed

  // Match Proposal handleDownloadExcel: numeric cells + comma format (#,##0), Illu raw
  const asExcelNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };
  const asSqFtEle = (ele, isKiosk) => {
    const w = asExcelNumber(ele?.width);
    const h = asExcelNumber(ele?.height);
    if (w == null || h == null) return null;
    if (isKiosk) {
      const u = asExcelNumber(ele?.unit);
      if (u == null) return null;
      return w * h * u * 2;
    }
    return w * h;
  };
  const ratePerMonthNumericEle = (ele, isKiosk) => {
    if (isKiosk && ele?.ratePerMonth != null && ele?.unit != null) {
      const rpm = Number(ele.ratePerMonth);
      const unit = Number(ele.unit);
      if (Number.isFinite(rpm) && Number.isFinite(unit) && unit !== 0) {
        const n = rpm / unit;
        return Number.isFinite(n) ? n : null;
      }
      return null;
    }
    return asExcelNumber(ele?.ratePerMonth);
  };
  const COMMA_NUMBER_FMT = "#,##0";
  const applyCommaNumFmtToDataRow = (excelRow, headers) => {
    (headers || []).forEach((h, i) => {
      const col = i + 1;
      const hNorm = normalizeHeader(h).toLowerCase();
      const isRatePerMonth =
        hNorm.includes("rate per") && hNorm.includes("month");
      const isPrint =
        hNorm.includes("printing") && hNorm.includes("charg");
      const isMount =
        hNorm.includes("mounting") && hNorm.includes("charg");
      const isInnovation =
        hNorm.includes("innovation") && hNorm.includes("charg");
      if (!isRatePerMonth && !isPrint && !isMount && !isInnovation) return;
      const cell = excelRow.getCell(col);
      if (typeof cell.value === "number" && Number.isFinite(cell.value)) {
        cell.numFmt = COMMA_NUMBER_FMT;
      }
    });
  };

  const handleDownloadExcel = async () => {
    const effectiveClientName =
      (clientName && clientName.label)
        ? clientName.label
        : (inputValue && inputValue.trim())
          ? inputValue.trim()
          : "";
    let blob;
    try {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Proposal Data");

      // Add the header image
      const imageId = workbook.addImage({
        base64: dataImg, // Your base64 encoded image data here
        extension: "jpeg",
      });

      // Header: To / Client / Date only (no Campaign) — match Proposal handleDownloadExcel
      worksheet.getCell("A3").value = "To";
      worksheet.getCell("A4").value = "Client:";
      worksheet.getCell("A5").value = "Date:";

      worksheet.getCell("B3").value = "";
      worksheet.getCell("B4").value = effectiveClientName;
      worksheet.getCell("B5").value = moment().format("DD-MM-YYYY");

      ["A3", "A4", "A5"].forEach((c) => {
        // changed
        worksheet.getCell(c).font = { bold: true, size: 11 }; // changed
        worksheet.getCell(c).alignment = {
          horizontal: "left",
          vertical: "middle",
        }; // changed
      }); // changed

      ["B2", "B3", "B4", "B5"].forEach((c) => {
        // changed
        worksheet.getCell(c).font = { bold: true, size: 11 }; // changed
        worksheet.getCell(c).alignment = {
          horizontal: "left",
          vertical: "middle",
        }; // changed
      }); // changed

      worksheet.getColumn("A").width = 14; // changed

      let displayCostHeader;
      const hasSpecialRateChanged = proposalInventories.some(
        (ele) => ele.specialRate !== ele.ratePerMonth,
      );
      const isThereInnovationRate = proposalInventories.some(
        (ele) => ele.innovationRate,
      );

      console.log("proposalInventories is: ", proposalInventories);

      const isAllKiosk = proposalInventories.every(
        (ele) => ele.mediaVehicle === "Kiosk",
      );

      // Choose the title dynamically
      const pmChargeTitle = isAllKiosk
        ? "P & M Charges / Pole"
        : "Printing & Mounting Charges";

      const ratePerMonthTitle = isAllKiosk
        ? "Rate Per Month / Pole"
        : "Rate Per Month";

      if (packageRate) {
        displayCostHeader = [
          "Sr.No",
          "Location",
          "Media Type",
          "Size (W)",
          "Size (H)",
          ...(isAllKiosk ? ["Unit"] : []),
          "Sq Ft",
          "Illu",
          // ratePerMonthTitle,
          "Rate Per Month",
          "Package Rate",
          // pmChargeTitle,
          "Printing & Mounting Charges",
          "Available From",
          "Lat Long with Hyperlink",
        ];
      } else {
        if (!isThereInnovationRate) {
          if (hasSpecialRateChanged) {
            displayCostHeader = [
              "Sr.No",
              "Location",
              "Media Type",
              "Size (W)",
              "Size (H)",
              ...(isAllKiosk ? ["Unit"] : []),
              "Sq Ft",
              "Illu",
              "Rate Per\n Month",
              // ratePerMonthTitle,
              "Special Rate\n Per Month",
              // pmChargeTitle,
              "Printing\n Charges",
              "Mounting\n Charges",
              "Available From",
              "Lat Long\n with Hyperlink",
            ];
          } else {
            displayCostHeader = [
              "Sr.No",
              "Location",
              "Media Type",
              "Size (W)",
              "Size (H)",
              ...(isAllKiosk ? ["Unit"] : []),
              "Sq Ft",
              "Illu",
              // ratePerMonthTitle,
              // pmChargeTitle,
              "Rate Per\n Month",
              //  pmChargeTitle,
              "Printing\n Charges",
              "Mounting \nCharges",
              "Available From",
              "Lat Long\n with Hyperlink",
            ];
          }
        } else {
          if (hasSpecialRateChanged) {
            displayCostHeader = [
              "Sr.No",
              "Location",
              "Media Type",
              "Size (W)",
              "Size (H)",
              ...(isAllKiosk ? ["Unit"] : []),
              "Sq Ft",
              "Illu",
              // ratePerMonthTitle,
              "Rate Per\n Month",
              "Special Rate\n Per Month",
              // pmChargeTitle,
              "Printing\n Charges",
              "Mounting\n Charges",
              "Innovation\n Charges",
              "Available From",
              "Lat Long\n with Hyperlink",
            ];
          } else {
            displayCostHeader = [
              "Sr.No",
              "Location",
              "Media Type",
              "Size (W)",
              "Size (H)",
              ...(isAllKiosk ? ["Unit"] : []),
              "Sq Ft",
              "Illu",
              "Rate Per\n Month",
              // ratePerMonthTitle,
              // pmChargeTitle,
              "Printing\n Charges",
              "Mounting\n Charges",
              "Innovation\n Charges",
              "Available From",
              "Lat Long\n with Hyperlink",
            ];
          }
        }
      }
      const lastColIndex = displayCostHeader.length;
      const lastColLetter = getExcelColumnLetter(lastColIndex);
      const logoRange = `${lastColLetter}2:${lastColLetter}5`;
      worksheet.addImage(imageId, logoRange);
      worksheet.mergeCells(logoRange);

      const wrapHeaders = [
        "Rate Per Month",
        "Special Rate Per Month",
        "Printing Charges",
        "Mounting Charges",
        "Innovation Charges",
        "Lat Long with Hyperlink",
        "Printing & Mounting Charges",
      ].map(normalizeHeader);
      const headerRow = worksheet.addRow(displayCostHeader);
      headerRow.font = { bold: true };

      // Apply alignment, border, and background color
      displayCostHeader.forEach((header, index) => {
        const cell = headerRow.getCell(index + 1);
        const shouldWrap = wrapHeaders.some(
          (
            key, // changed
          ) => header.replace(/\n/g, " ").includes(key), // changed
        );

        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" }, // Yellow background
        };

        // ✅ Force Wrap Text inside the cell
        cell.alignment = {
          wrapText: shouldWrap, // Enable wrap text
          horizontal: "center",
          vertical: "middle",
        };
      });

      headerRow.getCell(1).alignment = {
        horizontal: "center",
        vertical: "middle",
        wrapText: true,
      };

      // ✅ Increase row height to make space for the wrapped text
      headerRow.height = 60; // Adjust as needed

      worksheet.columns.forEach((column) => {
        column.alignment = {
          // wrapText: true,
          vertical: "middle",
          horizontal: "center",
        };
        column.width = 20; // Adjust as needed
      });
      worksheet.getColumn("A").alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      worksheet.getColumn("B").alignment = {
        horizontal: "left",
        vertical: "middle",
      };

      // Meta labels left; column A default center for table
      ["A3", "A4", "A5", "B3", "B4", "B5"].forEach((addr) => {
        worksheet.getCell(addr).alignment = {
          horizontal: "left",
          vertical: "middle",
        };
      });

      let BlockedInvs = await listBlockedInventories();

      let totalOfRPM = 0; // changed
      let totalOfSR = 0; // changed
      let totalOfPC = 0; // changed
      let totalOfMC = 0; // changed
      let totalOfPMC = 0; // changed
      let totalOfInnovation = 0; // changed
      proposalInventories.forEach((ele, index) => {
        let isInventoryBlocked = false;
        if (BlockedInvs.length > 0) {
          if (BlockedInvs.includes(ele?._id)) {
            isInventoryBlocked = true;
          }
        }
        // console.log("Invs are: ", ele);

        let printingMountingPerUnit;

        if (isAllKiosk) {
          printingMountingPerUnit = ele?.unit
            ? ((Number(ele?.printingCharge) || 0) +
              (Number(ele?.mountingCharge) || 0)) /
            ele.unit
            : "-";
        }

        if (Number(ele?.ratePerMonth)) {
          totalOfRPM += ele?.ratePerMonth;
        }
        if (Number(ele?.specialRate)) {
          totalOfSR += ele?.specialRate;
        }
        if (Number(ele?.mountingCharge)) {
          totalOfMC += ele?.mountingCharge;
        }
        if (Number(ele?.printingCharge)) {
          totalOfPC += ele?.printingCharge;
        }
        if (Number(ele?.innovationRate)) {
          totalOfInnovation += ele?.innovationRate;
        }

        totalOfPMC +=
          (Number(ele?.mountingCharge) || 0) +
          (Number(ele?.printingCharge) || 0);

        console.log("ELe is", ele);

        const latLongHyperlink = `https://www.google.com/maps?q=${ele?.lat},${ele?.lng}`;

        let availableText = getProposalAvailableFromLabel(ele);
        if (isInventoryBlocked && availableText !== "-") {
          availableText += " / BLOCKED";
        }

        let row;
        if (packageRate) {
          row = [
            index + 1,
            ele?.location || "-",
            ele.mediaVehicle || "-",
            asExcelNumber(ele?.width),
            asExcelNumber(ele?.height),
            ...(isAllKiosk ? [asExcelNumber(ele?.unit)] : []),
            asSqFtEle(ele, isAllKiosk),
            ele?.Illu ?? "-",
            ratePerMonthNumericEle(ele, isAllKiosk),
            packageRate ?? "-",
            isAllKiosk
              ? asExcelNumber(printingMountingPerUnit)
              : asExcelNumber(
                (Number(ele?.printingCharge) || 0) +
                (Number(ele?.mountingCharge) || 0),
              ),
            availableText,
            "-",
          ];
        } else {
          if (!isThereInnovationRate) {
            if (hasSpecialRateChanged) {
              row = [
                index + 1,
                ele?.location || "-",
                ele.mediaVehicle || "-",
                asExcelNumber(ele?.width),
                asExcelNumber(ele?.height),
                ...(isAllKiosk ? [asExcelNumber(ele?.unit)] : []),
                asSqFtEle(ele, isAllKiosk),
                ele?.Illu ?? "-",
                ratePerMonthNumericEle(ele, isAllKiosk),
                asExcelNumber(ele?.specialRate),
                isAllKiosk
                  ? asExcelNumber(printingMountingPerUnit)
                  : asExcelNumber(ele?.printingCharge),
                isAllKiosk ? null : asExcelNumber(ele?.mountingCharge),
                availableText,
                "-",
              ];
            } else {
              row = [
                index + 1,
                ele?.location || "-",
                ele.mediaVehicle || "-",
                asExcelNumber(ele?.width),
                asExcelNumber(ele?.height),
                ...(isAllKiosk ? [asExcelNumber(ele?.unit)] : []),
                asSqFtEle(ele, isAllKiosk),
                ele?.Illu ?? "-",
                ratePerMonthNumericEle(ele, isAllKiosk),
                isAllKiosk
                  ? asExcelNumber(printingMountingPerUnit)
                  : asExcelNumber(ele?.printingCharge),
                isAllKiosk ? null : asExcelNumber(ele?.mountingCharge),
                availableText,
                "-",
              ];
            }
          } else {
            if (hasSpecialRateChanged) {
              row = [
                index + 1,
                ele?.location || "-",
                ele.mediaVehicle || "-",
                asExcelNumber(ele?.width),
                asExcelNumber(ele?.height),
                ...(isAllKiosk ? [asExcelNumber(ele?.unit)] : []),
                asSqFtEle(ele, isAllKiosk),
                ele?.Illu ?? "-",
                ratePerMonthNumericEle(ele, isAllKiosk),
                asExcelNumber(ele?.specialRate),
                isAllKiosk
                  ? asExcelNumber(printingMountingPerUnit)
                  : asExcelNumber(ele?.printingCharge),
                isAllKiosk ? null : asExcelNumber(ele?.mountingCharge),
                asExcelNumber(ele?.innovationRate),
                availableText,
                ele.lat || "-",
                ele.lng || "-",
              ];
            } else {
              row = [
                index + 1,
                ele?.location || "-",
                ele.mediaVehicle || "-",
                asExcelNumber(ele?.width),
                asExcelNumber(ele?.height),
                ...(isAllKiosk ? [asExcelNumber(ele?.unit)] : []),
                asSqFtEle(ele, isAllKiosk),
                ele?.Illu ?? "-",
                ratePerMonthNumericEle(ele, isAllKiosk),
                isAllKiosk
                  ? asExcelNumber(printingMountingPerUnit)
                  : asExcelNumber(ele?.printingCharge),
                isAllKiosk ? null : asExcelNumber(ele?.mountingCharge),
                asExcelNumber(ele?.innovationRate),
                availableText,
                "-",
              ];
            }
          }
        }
        row = row.map((val) =>
          typeof val === "number" && Number.isFinite(val)
            ? val
            : formatIndianAllNumbers(val),
        );
        const newRow = worksheet.addRow(row);
        applyCommaNumFmtToDataRow(newRow, displayCostHeader);
        newRow.getCell(1).alignment = {
          horizontal: "center",
          vertical: "middle",
        };

        // Apply borders to each cell in the newly added row
        row.forEach((cellValue, cellIndex) => {
          newRow.getCell(cellIndex + 1).border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });
        const latLongIndex =
          displayCostHeader.findIndex((h) => h.includes("Lat Long")) + 1; // changed
        if (latLongIndex > 0) {
          // changed
          const latLongCell = newRow.getCell(latLongIndex); // changed
          latLongCell.value = {
            text: "View on Map",
            hyperlink: latLongHyperlink,
          }; // changed
          latLongCell.alignment = {
            wrapText: true,
            vertical: "middle",
            horizontal: "center",
          }; // changed
          latLongCell.font = { color: { argb: "0000FF" }, underline: true }; // changed
        } // changed

        const availableFromIndex =
          displayCostHeader.indexOf("Available From") + 1; // +1 because ExcelJS is 1-based
        if (availableFromIndex > 0 && isInventoryBlocked) {
          newRow.getCell(availableFromIndex).font = {
            color: { argb: "FF0000" },
          }; // Red font
        }
      });
      let displayCostHeader2 = [];
      for (let i of displayCostHeader) {
        displayCostHeader2.push("");
      }

      //🎈🎈🎈🎈
      let totalRow;
      if (packageRate) {
        totalRow = [
          "",
          "Total",
          "",
          "",
          "",
          ...(isAllKiosk ? [""] : []),
          "",
          "",
          totalOfRPM,
          "",
          totalOfPMC,
          // "0",
          "",
          "",
          // "",
        ];
      } else {
        if (!isThereInnovationRate) {
          if (hasSpecialRateChanged) {
            totalRow = [
              "",
              "Total",
              "",
              "",
              "",
              ...(isAllKiosk ? [""] : []),
              "",
              "",
              totalOfRPM || "-",
              totalOfSR,
              totalOfPC, // changed
              totalOfMC,
              // formatIndianNumber(totalOfMC),
              "",
              "",
              // "",
            ];
          } else {
            totalRow = [
              // "",
              "",
              "Total",
              "",
              "",
              "",
              ...(isAllKiosk ? [""] : []),
              "",
              "",
              totalOfRPM,
              totalOfPC,
              totalOfMC,
              // formatIndianNumber(totalOfMC),
              "",
              "",
              // "",
            ];
          }
        } else {
          if (hasSpecialRateChanged) {
            totalRow = [
              // "",
              "",
              "Total",
              "",
              "",
              "",
              ...(isAllKiosk ? [""] : []),
              "",
              "",
              totalOfRPM,
              totalOfSR,
              totalOfPC,
              totalOfMC,
              // formatIndianNumber(totalOfMC),
              totalOfInnovation,
              "",
              "",
              // "",
            ];
          } else {
            totalRow = [
              // "",
              "",
              "Total",
              "",
              "",
              "",
              ...(isAllKiosk ? [""] : []),
              "",
              "",
              totalOfRPM,
              totalOfPC,
              totalOfMC,
              // formatIndianNumber(totalOfMC),
              totalOfInnovation,
              "",
              "",
              // "",
            ];
          }
        }
      }
      //🎈🎈🎈🎈

      totalRow = totalRow.map((val) =>
        typeof val === "number" && Number.isFinite(val)
          ? val
          : formatIndianAllNumbers(val),
      );
      const anotherRow = worksheet.addRow(totalRow);
      applyCommaNumFmtToDataRow(anotherRow, displayCostHeader);
      anotherRow.getCell(1).alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      worksheet.mergeCells(
        `B${proposalInventories.length + 8}:G${proposalInventories.length + 8}`,
      );
      worksheet.getCell(`B${proposalInventories.length + 8}`).font = {
        bold: true,
      };
      worksheet.getCell(`B${proposalInventories.length + 8}`).alignment =
      {
        vertical: "middle",
        horizontal: "center",
      };

      displayCostHeader2.forEach((header, index) => {
        worksheet
          .getRow(proposalInventories.length + 8)
          .getCell(index + 1).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        // worksheet.getCell(`B${index+1}`).font = { bold: true };
      });

      // Merge the 'Rate Per Month' column cells if packageRate exists
      if (packageRate) {
        const startRow = 8;
        const endRow = proposalInventories.length + 7;
        worksheet.mergeCells(`J${startRow}:J${endRow}`);
        worksheet.getCell(`J${startRow}`).value =
          formatIndianNumber(packageRate);
        worksheet.getCell(`J${startRow}`).font = { bold: true };
        worksheet.getCell(`J${startRow}`).alignment = {
          vertical: "middle",
          horizontal: "center",
        };
      }

      worksheet.addRow(displayCostHeader2).font = { bold: true };
      displayCostHeader2.forEach((header, index) => {
        worksheet
          .getRow(worksheet.lastRow.number - 1)
          .getCell(index + 1).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        worksheet.getRow(worksheet.lastRow.number - 1).getCell(index + 1).fill =
        {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFF00" }, // Yellow background
        };
      });

      worksheet.addRow([""]);

      let currentRow = worksheet.lastRow ? worksheet.lastRow.number + 1 : 1;
      // Add rows and merge cells for notes
      const rowsToMerge = [
        "* Sites are subject to availability at the time of your confirmation.",
        "* Site will be block only for one day.",
        "* Mail Conﬁrmation or Purchase Order is mandatory to start the campaign.",
        "* GST (18%) will be charged as per government rules and regulations.",
        "* For any reasons, if your flex is damaged, it will be your responsibility to provide us with a new flex.",
      ];

      rowsToMerge.forEach((text, index) => {
        worksheet.addRow([""]);
        worksheet.mergeCells(`A${currentRow}:F${currentRow}`);
        const row = worksheet.getRow(currentRow);
        row.getCell(1).value = text; // Set the text in the first cell of the merged range
        row.getCell(1).font = { bold: true };
        row.getCell(1).alignment = { vertical: "middle", horizontal: "left" }; // Center align text
        currentRow++;
      });

      // Footer: merge across table width so text isn't clipped
      worksheet.addRow([""]);
      const footerLastCol = getExcelColumnLetter(displayCostHeader.length);
      const addFooterLine = (text) => {
        worksheet.addRow([text]);
        const r = worksheet.lastRow.number;
        worksheet.mergeCells(`A${r}:${footerLastCol}${r}`);
        const row = worksheet.getRow(r);
        row.getCell(1).value = text;
        row.getCell(1).font = { bold: true };
        row.getCell(1).alignment = {
          vertical: "middle",
          horizontal: "left",
          wrapText: true,
        };
      };
      addFooterLine("Thanks & Regards");
      addFooterLine("YELLOW SPOT OOH");

      // Column widths
      const mediumWidth = 15;
      const largeWidth = ["B"];
      const cWidth = ["C"];
      const specificWidth = ["D", "E"];
      const fWidth = ["F"];
      const gWidth = ["G"];
      const widthForLatLong = ["M", "N"];
      const hijWidth = ["H", "I", "J"];
      const kWidth = ["K"];


      worksheet.columns.forEach((column) => {
        if (largeWidth.includes(column.letter)) {
          column.width = 45;
        } else if (cWidth.includes(column.letter)) {
          column.width = 9;
        } else if (specificWidth.includes(column.letter)) {
          column.width = 8;
        } else if (fWidth.includes(column.letter)) {
          column.width = 6;
        } else if (gWidth.includes(column.letter)) {
          column.width = 5;
        } else if (widthForLatLong.includes(column.letter)) {
          column.width = 18;
        } else if (hijWidth.includes(column.letter)) {
          column.width = 10;
        } else if (kWidth.includes(column.letter)) {
          column.width = 14;
        } else {
          column.width = mediumWidth;
        }
      });
      worksheet.getColumn("A").width = 6;

      // Keep header values readable
      worksheet.getColumn("B").width = 60;

      // Increase height of row 7
      const rowNumber = 7;
      const desiredHeight = 50; // specify the desired height in points

      worksheet.getRow(rowNumber).height = desiredHeight;
      // Center align content vertically in row 7
      worksheet.getRow(rowNumber).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        }; // Center align vertically and horizontally
      });

      // worksheet.getColumn(10).width = 25;
      // worksheet.getColumn(11).width = 25;
      // worksheet.getColumn(12).width = 22;

      const buffer = await workbook.xlsx.writeBuffer();
      blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(
        blob,
        `${effectiveClientName}_Proposal_${moment().format("YYYY-MM-DD")}.xlsx`,
      );
    } catch (err) {
      notification.error({ message: err.message });
      setShowLoader(false);
    } finally {
      await generatePresentation();
    }

    const mime =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const token = window.localStorage.getItem("token");

    // Generate a unique filename
    const fileName = `${effectiveClientName} Proposal_${moment().format(
      "YYYY-MM-DD",
    )}.xlsx`;

    const requestBody = {
      fileName,
      mime: mime,
      "Content-Type": mime,
    };
    setBodyOfEmail(`<p>Dear Sir,</p>
    <br/>
    <p>Please find below the links to download the proposal documents:</p>
    <br/>
    <br/>
    <p><a href="${encodeURI(
      finalUrl1,
    )}">Download PowerPoint presentation</a></p>
    <br/>
    <br/>
    <p><a href="${encodeURI(finalUrl2)}">Download Excel file</a></p>
    <br/>
    <br/>
    <p>Awaiting your positive response for the same.</p>
    <br/>
    <p>Best regards,</p>
    <br/>
    <p>Yellow Spot</p>
    <br/>
   `);
    try {
      // Step 1: Get the upload policy
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/uploadPolicyForEmails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${token}`,
          },
          body: JSON.stringify(requestBody),
        },
      );

      if (!response.ok) {
        console.error(`HTTP error! Status: ${response.status}`);
        return;
      }

      const data = await response.json();

      if (!data?.data?.fields || !data?.data?.url) {
        return;
      }

      // Step 2: Prepare FormData with the file (match S3 policy - same as AddInventoryContainer)
      const formData = new FormData();
      const expectedContentType = mime;

      Object.entries(data.data.fields).forEach(([key, value]) => {
        if (
          key.toLowerCase() === "content-type" ||
          key.toLowerCase() === "mime"
        ) {
          formData.append(key, expectedContentType);
        } else {
          formData.append(key, value);
        }
      });

      if (
        !formData.has("Content-Type") &&
        !formData.has("content-type") &&
        !formData.has("mime")
      ) {
        formData.append("Content-Type", expectedContentType);
      }

      const file = new File([blob], fileName, { type: mime });
      formData.append("file", file);

      // Step 3: Upload the file (set final URL only after success - match AddInventoryContainer)
      try {
        const uploadResponse = await fetch(data.data.url, {
          method: "POST",
          body: formData,
        });

        if (uploadResponse.ok) {
          const key = data.data.fields?.key ?? data.filePath;
          finalurlExcel = convertS3ToCloudFront(`${data.data.url}/${key}`);
          setFinalUrl2(finalurlExcel);
          console.log("Excel uploaded successfully:", finalurlExcel);
          console.log(
            "Here both the urls have been generated",
            finalurlPpt,
            finalurlExcel,
          );
          const requestBody = {
            generatePropId: propId,
            pptLink: finalurlPpt,
            excelLink: finalurlExcel,
          };
          const response = await fetch(
            `${apiBaseUrl}/inventoryManagement/insertUrlInProposal`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: `Token ${token}`,
              },
              body: JSON.stringify(requestBody),
            },
          );
          // if(response.ok){
          //   finalurlExcel = "";
          //   finalurlPpt = "";
          //   propId = "";
          // }
        } else {
          console.log(
            "Error occurred:",
            uploadResponse.status,
            uploadResponse.statusText,
          );
        }
      } catch (uploadError) {
        console.error("Error occurred during file upload:", uploadError);
      }
    } catch (error) {
      console.error("Error fetching upload policy:", error);
    }
  };

  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }
  const [urlsReady, setUrlsReady] = useState(false);
  useEffect(() => {
    const lookLinkGenerated = () => {
      console.log(
        finalurlExcel &&
        finalurlExcel.includes("http") &&
        finalurlPpt &&
        finalurlPpt.includes("http"),
      );
      return (
        finalurlExcel &&
        finalurlExcel.includes("http") &&
        finalurlPpt &&
        finalurlPpt.includes("http")
      );
    };

    // Check if both URLs are valid and update state accordingly
    if (lookLinkGenerated()) {
      setUrlsReady(true);
    }
  }, [finalurlExcel, finalurlPpt]);

  const isDateBlocked = (currentDate, inventories) => {
    if (!currentDate) return false;

    // Disable past dates
    const today = moment().startOf("day");
    if (currentDate.isBefore(today) && blockingType != "management") {
      return true;
    }

    currentDate.format("YYYY-MM-DD");

    // Check bookings and blockedDates
    return inventories?.some((inventory) => {
      const bookingBlocked = isBookingBlocked(currentDate, inventory.Bookings);
      const premiumBlocked = isPremiumBlocked(
        currentDate,
        inventory.blockedDates,
      );
      const managementBlocked = isManagementBlocked(
        currentDate,
        inventory.blockedDates,
      );

      // Block date if it matches either condition
      return bookingBlocked || premiumBlocked || managementBlocked;
    });
  };

  const isBookingBlocked = (currentDate, bookings) => {
    const dateString = currentDate.format("YYYY-MM-DD");

    return bookings?.some(({ startDate, endDate }) => {
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");
      return dateString >= start && dateString <= end;
    });
  };

  const isPremiumBlocked = (currentDate, blockedDates) => {
    const dateString = currentDate.format("YYYY-MM-DD");

    const blockedDetail = blockedDates?.find((bd) => {
      if (!bd) return false;
      const { premiumBlock, blockedAt, blockedTill } = bd;
      if (premiumBlock === true && blockedAt && blockedTill) {
        const start = moment(blockedAt).format("YYYY-MM-DD");
        const end = moment(blockedTill).format("YYYY-MM-DD");
        return dateString >= start && dateString <= end;
      }
      return false;
    });

    return blockedDetail ? blockedDetail.blockedBy?.name : null;
  };

  const isManagementBlocked = (currentDate, blockedDates) => {
    const dateString = currentDate.format("YYYY-MM-DD");

    const blockedDetail = blockedDates?.find((bd) => {
      if (!bd) return false;
      const { managementBlock, blockedAt, blockedTill } = bd;
      if (managementBlock === true && blockedAt && blockedTill) {
        const start = moment(blockedAt).format("YYYY-MM-DD");
        const end = moment(blockedTill).format("YYYY-MM-DD");
        return dateString >= start && dateString <= end;
      }
      return false;
    });

    return blockedDetail ? "Management" : null;
  };

  //Downloading different File Types
  return (
    <div className="inventory-container parent-padding-container">
      <div
        className="spec-loader"
        style={{ display: showLoader ? "flex" : "none" }}
      >
        <MutatingDots
          visible={true}
          height="100"
          width="100"
          color="#f5d442"
          secondaryColor="#f5d442"
          radius="12.5"
          ariaLabel="mutating-dots-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />

        <div className="blinking-text">Downloading ..</div>
      </div>
      <div id="InventoryList">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flex: "1",
            gap: "1rem",
          }}
        >
          {/* <MultipleSelect titleName={"Areas"} initialItems={initialItems} selectedItems={selectedItems} handleChange={handleChange} width="50%" /> */}
          <MultipleSelect
            titleName={"Media Vehicle"}
            initialItems={itemsForMV}
            selectedItems={MVFiltering}
            handleChange={handleMVFiltering}
            width={isMobile ? "100%" : "50%"}
          />
        </div>

        <div id="BtnContainerCard">
          <ButtonComponent
            data="Generate Proposals"
            handleClick={handleClickProposals}
            buttonColor="#026E78"
            icon={<FaPlus />}
          />
          <ButtonComponent
            data="Book Inventory"
            handleClick={handleClickBookings}
            buttonColor="#026E78"
            icon={<FaPlus />}
          />
          <ButtonComponent
            data="Block"
            handleClick={handleBlockInventoriesInitiation}
            buttonColor="#026E78"
            icon={<FaPlus />}
          />
          {/* <ButtonComponent
            data="Book Suffix"
            handleClick={handleBookSuffix}
            buttonColor="#026E78"
            icon={<FaPlus />}
          /> */}
        </div>
      </div>
      <div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="label-headings">Inventory List</div>
          <div style={{ display: "flex", gap: "1rem" }}>
            {dataSourceB?.length > 0 && isCartUpdated && (
              <Button
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: ".5rem",
                  marginRight: "2rem",
                }}
                onClick={() => {
                  Modal.confirm({
                    title: "Reset Cart",
                    content: "Are you sure you want to reset the cart? All selected inventories will be cleared.",
                    okText: "Yes",
                    cancelText: "No",
                    onOk: () => {
                      dispatch(resetCart());
                      setDataSource(NaN);
                      setDataSourceB(NaN);
                    },
                  });
                }}
              >
                <IoIosRefresh />
                Reset Cart
              </Button>
            )}
            {bookingsOpen && (
              <ButtonComponent
                data="Create BDF with Excel"
                buttonColor="rgb(2, 110, 120)"
                handleClick={() => {
                  dispatch(addProposalInventories({ packageRate: null, invs: [] }));
                  dispatch(emptyDraft());
                  navigate(`/clients-bdf/direct-bdf`);
                }}
              />
            )}
            {bookingsOpen &&
              Object.values(checkedRecords).some((value) => value === true) && (
                <ButtonComponent
                  data="Book"
                  buttonColor="rgb(2, 110, 120)"
                  handleClick={() => {
                    setIsModalOpen(true);
                    setBookingModalOpen(true);
                    setClientName(null);
                  }}
                />
              )}
            {blockingOpen && (
              <ButtonComponent
                data="Premium Block with Excel"
                buttonColor="rgb(2, 110, 120)"
                handleClick={() => {
                  dispatch(emptyBlockInventories());
                  dispatch(addBlockInventories({ inventories: [] }));
                  navigate("/premiumBlock/create");
                }}
              />
            )}
            {blockingOpen &&
              Object.values(checkedRecords).some((value) => value === true) && (
                <ButtonComponent
                  data="Block Inventories"
                  buttonColor="rgb(2, 110, 120)"
                  handleClick={() => {
                    setBlockingModalOpen(true);
                    setClientName(null);
                  }}
                />
              )}
            {proposalsOpen &&
              Object.values(checkedRecords).some((value) => value === true) && (
                <ButtonComponent
                  data="Generate Proposals"
                  buttonColor="rgb(2, 110, 120)"
                  handleClick={() => setIsModalOpen(true)}
                />
              )}

            {/* {(proposalsOpen || bookingsOpen) && everyRecordsChecked(checkedRecords) && <Button onClick={handleDeSelectAll}>Deselect All</Button>}
                        {(proposalsOpen || bookingsOpen)  && <Button onClick={handleSelectAll}>Select All</Button>} */}
          </div>
        </div>
        <TableComponent columns={columns} dataSource={dataSource} />
        {/* {forceRender && null} */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            flexWrap: "wrap",
            margin: "20px 0px",
          }}
        >
          <Button
            icon={<PlusOutlined />}
            loading={loadingRemovedInvs}
            onClick={() => displayRemovedInvs()}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              padding: "1.5rem",
              width: "17rem",
            }}
          >
            Add Removed Inventories
          </Button>
          <Button
            icon={<PlusOutlined />}
            loading={loadingTradingInvs}
            onClick={() => displayTradingInvs()}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              padding: "1.5rem",
              width: "17rem",
            }}
          >
            Add existing Trading inventories
          </Button>
          <Button
            icon={<PlusOutlined />}
            onClick={() => setAddInventoryBoolean(true)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "1rem",
              padding: "1.5rem",
              width: "17rem",
            }}
          >
            Create new Trading inventory
          </Button>
        </div>
      </div>

      <Modal
        title={
          inventoryPickerType === "removed"
            ? "Choose Removed Inventories"
            : "Choose Trading Inventories"
        }
        open={openTradingInvs}
        onOk={handleOkOfTradingInv}
        onCancel={handleCloseTradingInv}
        width={900}
      >
        <Input
          placeholder="Search Any Field"
          value={tradingSearchText}
          onChange={(e) => handleTradingPickerFilterData(e)}
        />
        <div style={{ width: "100%", overflow: "auto", margin: "20px 0px" }}>
          <Table
            dataSource={allTradingInv}
            columns={columnsForTradingInvs}
            rowKey="_id"
            loading={loadingTradingInvs}
          />
        </div>
      </Modal>

      <Modal
        title={customTitle}
        footer={isModalOpen}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        className="inventory-proposal-modal"
        width={800}
      >
        {/* <button onClick={()=>setShowLoader(true)}>chekc</button> */}

        {!bookingModalOpen ? (
          <Alert
            message="You can only Send Email after the proposal is generated"
            type="warning"
            showIcon
            style={{ padding: "10px", margin: "10px", width: "fitContent" }}
          />
        ) : null}

        <div className="custom-slider-container" onWheel={handleScroll}>
          <div className="custom-slider" ref={sliderRef}>
            {proposalInventories &&
              proposalInventories
                .slice(
                  currentPage * itemsPerPage,
                  (currentPage + 1) * itemsPerPage,
                )
                .map((ele) => (
                  <div key={ele._id} className="slider-item">
                    <Row>
                      <div id="CarousalHeight">
                        <Col lg={8}>
                          <div>
                            <img
                              src={
                                convertS3ToCloudFront(ele.img) ||
                                "./images/loaderImage.png"
                              }
                              alt=""
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        </Col>
                        <Col
                          lg={16}
                          className="right-side-container-content"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <div className="right-side-container-content-r">
                            <div>
                              <div>Area</div>
                              <div>{ele.area}</div>
                            </div>
                            <div>
                              <div>Location</div>
                              <div>{ele.location}</div>
                            </div>
                            <div>
                              <div>Media Vehicle</div>
                              <div>{ele.mediaVehicle}</div>
                            </div>
                            <div>
                              <div>Illu</div>
                              <div>{ele.Illu}</div>
                            </div>
                            <div>
                              <div>Rate Per Month</div>
                              <div>{ele.ratePerMonth}</div>
                            </div>
                          </div>
                          <div className="right-side-container-content-l">
                            <div>
                              <div>Width</div>
                              <div>{ele.width}</div>
                            </div>
                            <div>
                              <div>Height</div>
                              <div>{ele.height}</div>
                            </div>
                            <div>
                              <div>Area (Sq.ft)</div>
                              <div>{ele.sqFt}</div>
                            </div>
                            <div>
                              <div>Units</div>
                              <div>{ele.unit}</div>
                            </div>
                          </div>
                        </Col>
                      </div>
                      <Col lg={24}>
                        <div className="input-containers-container">
                          <Form.Item
                            label="Printing Charge"
                            rules={[
                              { required: true, message: "Please input!" },
                              {
                                pattern: /^[0-9]*$/,
                                message: "Please enter numbers only!",
                              },
                            ]}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "7px",
                              }}
                            >
                              <button
                                disabled={activatePR}
                                onClick={handlePCDecrement(ele._id)}
                                style={{
                                  padding: "3px 16px",
                                  borderRadius: "4px",
                                  border: "none",
                                  background: "#e17374",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              >
                                -
                              </button>
                              <Input
                                disabled={activatePR}
                                value={ele?.printingCharge}
                                min={0}
                                step={2}
                                precision={0}
                                onChange={handlePrintingCharge(ele._id)}
                                placeholder="Printing Charge"
                                style={{ flex: "1" }}
                              />
                              <button
                                disabled={activatePR}
                                onClick={handlePCIncrement(ele._id)}
                                style={{
                                  padding: "3px 16px",
                                  marginRight: "4px",
                                  borderRadius: "4px",
                                  border: "none",
                                  background: "#69b0f1",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              >
                                +
                              </button>
                            </div>
                          </Form.Item>
                          <Form.Item label="Mounting Charge">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "7px",
                              }}
                            >
                              <button
                                disabled={activatePR}
                                onClick={handleMCDecrement(ele._id)}
                                style={{
                                  padding: "3px 16px",
                                  borderRadius: "4px",
                                  border: "none",
                                  background: "#e17374",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              >
                                -
                              </button>
                              <Input
                                disabled={activatePR}
                                value={ele?.mountingCharge}
                                onChange={handleMountingCharge(ele._id)}
                                placeholder="Mounting Charge"
                                style={{ flex: "1" }}
                              />
                              <button
                                disabled={activatePR}
                                onClick={handleMCIncrement(ele._id)}
                                style={{
                                  padding: "3px 16px",
                                  marginRight: "4px",
                                  borderRadius: "4px",
                                  border: "none",
                                  background: "#69b0f1",
                                  color: "white",
                                  cursor: "pointer",
                                }}
                              >
                                +
                              </button>
                            </div>
                          </Form.Item>
                          <Form.Item label="Innovation Charge">
                            <Input
                              disabled={activatePR}
                              value={
                                ele?.innovationRate === 0
                                  ? "0"
                                  : ele?.innovationRate
                              }
                              onChange={handleInnovationRate(ele._id)}
                              placeholder="Innovation Rate"
                            />
                          </Form.Item>
                          <Form.Item label="Special Rate Per Month">
                            <Input
                              disabled={activatePR}
                              style={{ border: "#FFCB10 3px solid" }}
                              value={
                                ele?.specialRate === 0 ? "0" : ele?.specialRate
                              }
                              onChange={handleSpecialRate(ele._id)}
                              placeholder="Rate per Month"
                            />
                            {ele?.specialRate && (
                              <div>
                                Discount : (
                                {ele?.ratePerMonth - ele?.specialRate} Rs){" "}
                                {discountCalc(
                                  ele?.specialRate,
                                  ele?.ratePerMonth,
                                )}{" "}
                                %
                              </div>
                            )}
                          </Form.Item>
                        </div>
                      </Col>
                    </Row>
                  </div>
                ))}
          </div>
          {renderPagination(totalPages, currentPage, setCurrentPage)}
        </div>
        <div id="FooterEdit">
          <div style={{ display: "flex", flexDirection: "column" }}>
            {bookingModalOpen ? null : ( // </Form.Item> //   <Input value={GSTNumber} onChange={(e) => setGSTNumber(e.target.value)} /> // > //   label="GST Number" // <Form.Item
              <Form.Item label="Name of the Client">
                <AutoComplete
                  options={options}
                  onSelect={onSelect}
                  onSearch={onSearch}
                  value={inputLabel || inputValue} // Display input label if available, otherwise input value
                  onChange={(value) => {
                    setInputValue(value);
                    setInputLabel("");
                  }}
                  // onBlur={onBlur}
                  placeholder="Select a client"
                  style={{ width: "100%" }}
                  allowClear
                  onClear={onClear} // Handle the clear event
                >
                  <Input suffix={loading ? <Spin size="small" /> : null} />
                </AutoComplete>
              </Form.Item>
            )}
          </div>

          <div>
            {activatePR && (
              <Form.Item label="Package Rate" style={{ marginBottom: "0px" }}>
                <Input
                  placeholder="Enter the Package Rate"
                  value={packageRate}
                  onChange={(e) => setPackageRate(Number(e.target.value))}
                />
              </Form.Item>
            )}
            <Switch
              style={{ margin: "0px 5px" }}
              checkedChildren="REMOVE 20% FROM ALL"
              unCheckedChildren="APPLY 20% TO ALL"
              defaultChecked={applyPer} // Set the default checked status based on state
              onChange={applyDisCountToAll} // Handle the onChange event
            />
            {/* <Switch
              checkedChildren="Package Rate"
              unCheckedChildren="Package Rate"
              defaultChecked={activatePR} // Set the default checked status based on state
              onChange={handleActivatePR} // Handle the onChange event
            /> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "10px 0px",
          }}
        >
          {!bookingModalOpen ? (
            <>
              <Button
                type="primary"
                style={{ margin: "5px 0px" }}
                disabled={finalUrl1 != null || finalUrl2 != null ? false : true}
                onClick={() => setModalVisible(true)}
              >
                Send Email
              </Button>

              {
                // Log the value of urlsReady
                finalUrl1 && finalUrl2 && (
                  <Share pptLink={finalUrl1} excelLink={finalUrl2} />
                )
              }
            </>
          ) : null}
          <div className="footer-buttons">
            {/* <Button type="primary" onClick={handleDownloadExcel}><MdOutlineFileDownload /> &nbsp;Generate Excel</Button>
                        <Button type="primary" onClick={generatePresentation}><MdOutlineFileDownload /> &nbsp;Generate ppt</Button> */}
            {bookingModalOpen ? (
              <Button type="primary" onClick={generateBDF}>
                <MdOutlineFileDownload /> &nbsp;Generate BDF
              </Button>
            ) : (
              <Button type="primary" onClick={generateProposal}>
                <MdOutlineFileDownload /> &nbsp;{buttonText}
              </Button>
            )}
            {/* <Button type="primary" onClick={generatePresentation}><MdOutlineFileDownload /> &nbsp;Generate Ppt</Button> */}
          </div>
        </div>
      </Modal>

      {/* <Modal title="   " open={bookingModalOpen} onOk={handleBookingOk} footer="" onCancel={handleBookingModalCancel} centered className="inventory-proposal-modal" width={800}

      >
        <div className="inventory-booking-modal-main">
          <TableComponent dataSource={bookInventories} columns={columnsForBookings} />
        </div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Form.Item
            label="Client Name"
          >
            <Input placeholder="Enter the name of the client" value={clientName} onChange={(e) => setClientName(e.target.value.trim())} />
          </Form.Item>
          <div style={{ display: "flex", gap: "1rem" }}>
            <Button key="cancel" onClick={handleBookingModalCancel}>
              Cancel
            </Button>
            <Button key="confirm" type="primary" onClick={handleBookingConfirmation}>
              Confirm Booking
            </Button>
          </div>
        </div>
      </Modal> */}

      <Modal
        width={700}
        open={inventoryView}
        onOk={() => setInventoryView(false)}
        onCancel={() => setInventoryView(false)}
      >
        {selectedInventory && (
          <div>
            <div className="card-modal-body">
              <div className="modal-img-container">
                <img
                  style={{ width: "100%" }}
                  src={
                    convertS3ToCloudFront(selectedInventory.img) ||
                    "./images/loaderImage.png"
                  }
                  alt=""
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  gap: "1rem",
                }}
              >
                <div
                  style={{
                    fontWeight: "600",
                    color: "gray",
                    display: "flex",
                    gap: "4rem",
                  }}
                >
                  <span>Code No: {selectedInventory?.CodeNo}</span>
                  <span>CAS Code: {selectedInventory?.CASCode}</span>
                </div>
                <span style={{ color: "#1A91FF", fontSize: "1rem" }}>
                  {/* <CiLocationArrow1 /> */}
                  <a
                    className="location"
                    onClick={(e) => {
                      handleLocationClick(
                        selectedInventory.lat,
                        selectedInventory.lng,
                      );
                    }}
                  >
                    <CiLocationArrow1 />
                    {selectedInventory.locations.name}
                  </a>
                  {/* <Link to={selectedInventory?.locations.name}>{selectedInventory?.locations.name}</Link> */}
                </span>
              </div>
            </div>
            <div className="modal-info">
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  gap: "3rem",
                }}
              >
                <ul>
                  <li>
                    <div>Media Vehicle</div>
                    <div>{selectedInventory?.typeOfMedia?.name}</div>
                  </li>
                  <li>
                    <div>Illu</div>
                    <div>{selectedInventory?.Illu}</div>
                  </li>
                  {/* <li><div>Inventory</div><div>Het</div></li> */}
                  <li>
                    <div>Rate per month</div>
                    <div>{selectedInventory?.ratePerMonth}</div>
                  </li>
                  <li>
                    <div>Availability</div>
                    <div>
                      {
                        dateAvailability(
                          selectedInventory?.Bookings,
                          false,
                          selectedInventory,
                        ).status
                      }
                    </div>
                  </li>
                </ul>

                <RectangleGenerator
                  width={selectedInventory?.width}
                  height={selectedInventory?.height}
                  typeOfMediaName={selectedInventory?.typeOfMedia?.name}
                />
              </div>
            </div>
          </div>
        )}
      </Modal>

      <Modal
        open={addInventoryBoolean}
        onCancel={() => {
          setAddInventoryBoolean(false);
        }}
        width={1000}
        footer={[
          <Button
            key="back"
            onClick={() => {
              setAddInventoryBoolean(false);
            }}
          >
            Cancel
          </Button>,
        ]}
      >
        <div className="add-inventory-container">
          <div className="add-inventory-form">
            <div className="label-headings">Add Trading Inventory</div>
            <Form
              form={form}
              name="basic"
              onFinish={onFinish}
              initialValues={{ remember: true }}
              layout="vertical"
            >
              {/* First Row */}
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label={
                      <span>
                        City <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="city"
                    rules={[
                      { required: true, message: "Please add the city!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={
                      <span>
                        Area <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="area"
                    rules={[
                      { required: true, message: "Please add the Area!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={
                      <span>
                        Media Vehicle <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="mediaType"
                    rules={[
                      {
                        required: true,
                        message: "Please select the media vehicle!",
                      },
                    ]}
                  >
                    <Select placeholder="Please select">
                      <Option value="Gantry">Gantry</Option>
                      <Option value="Unipole">Unipole</Option>
                      <Option value="Hoarding">Hoarding</Option>
                      <Option value="Cantilever">Cantilever</Option>
                      <Option value="LED">LED</Option>
                      <Option value="Kiosk">Kiosk</Option>
                      {/* <Option value="Newspaper">Newspaper</Option>
                      <Option value="Magazine">Magazine</Option> */}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              {/* Second Row */}
              <Row gutter={16}>
                <Col span={16}>
                  <Form.Item
                    label={
                      <span>
                        Location <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="name"
                    rules={[
                      { required: true, message: "Please add the location!" },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={
                      <span>
                        Media Type/ILLU <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    name="illu"
                    rules={[
                      {
                        required: true,
                        message: "Please select the media Type!",
                      },
                    ]}
                  >
                    <Select placeholder="Please select">
                      <Option value="FL">FL</Option>
                      <Option value="BL">BL</Option>
                      <Option value="NL">NL</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <div
                style={{ display: "flex" }}
                className="add-inventory-third-row"
              >
                <div>
                  <div className="add-inventory-image-upload">
                    {imageUrl ? (
                      <img
                        src={selectedImage}
                        style={{
                          width: "200px",
                          // height: "200px",
                          minHeight: "200px",
                          objectFit: "cover",
                          border: "2px solid #ccc", // Add border
                          borderRadius: "5px", // Add border radius
                          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Add box shadow
                        }}
                      />
                    ) : (
                      "Upload image here"
                    )}
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<PlusOutlined />}
                      style={{ position: "absolute", top: "80%" }}
                      onClick={handleUpload}
                    />
                    <input
                      type="file"
                      multiple
                      style={{ display: "none" }}
                      className="imageFile"
                      onChange={handleFileChange}
                    />
                  </div>
                  {/* <Form.Item label="Upload" name="upload">
                                <Upload name="logo" action="/upload.do" listType="picture">
                                    <Button icon={<UploadOutlined />}>Click to upload</Button>
                                </Upload>
                            </Form.Item> */}
                </div>
                <div>
                  <div>
                    <Form.Item
                      label={
                        <span>
                          Suffix<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="suffix"
                      rules={[
                        {
                          required: true,
                          message: "Please select the suffix!",
                        },
                      ]}
                    >
                      <Select placeholder="Please select">
                        <Option value="HO">HO</Option>
                        <Option value="PRD">PRD</Option>
                        <Option value="PRN">PRN</Option>
                        <Option value="BR">BR</Option>
                        <Option value="OTH">OTH</Option>
                      </Select>
                    </Form.Item>


                    <Form.Item
                      label={
                        <span>
                          Width <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="width"
                      rules={[
                        {
                          required: true,
                          message: "Please input!",
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter numbers only!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      label={
                        <span>
                          Height <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="height"
                      rules={[
                        {
                          required: true,
                          message: "Please input!",
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter numbers only!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  {/* <div>
                    <Form.Item label="Code No." name="codeNo">
                      <Input />
                    </Form.Item>

                    <Form.Item label="CAS Code" name="casCode">
                      <Input />
                    </Form.Item>
                  </div> */}
                  <div>
                    {/* <Form.Item label="Vendor" name="vendor">
                      <Input />
                    </Form.Item> */}
                    <Form.Item
                      label={
                        <span>
                          Vendor <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="vendor"
                      rules={[
                        {
                          required: true,
                          message: "Please select the Vendor!",
                        },
                      ]}
                    >
                      <Select
                        placeholder="Please select"
                        showSearch
                        allowClear
                        optionLabelProp="label" // This ensures only name is visible after selection
                        filterOption={(input, option) =>
                          option.children[0].props.children
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {vendors?.map((vendor) => (
                          <Option
                            key={vendor?.name}
                            value={vendor?.name}
                            label={vendor?.name}
                          >
                            <div style={{ fontWeight: "bold" }}>
                              {vendor?.name}
                            </div>
                            <div style={{ fontSize: "12px", color: "#888" }}>
                              {vendor?.gstNumber
                                ? vendor?.gstNumber
                                : "No GST Number"}
                            </div>
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      label={
                        <span>
                          Rate Per Month <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="ratePerMonth"
                      rules={[
                        {
                          required: true,
                          message: "Please input!",
                        },
                        {
                          pattern: /^[0-9]*$/,
                          message: "Please enter numbers only!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item label={<span>Latitude</span>} name="lat">
                      <Input />
                    </Form.Item>
                    <Form.Item label={<span>Longitude</span>} name="lng">
                      <Input />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      label={
                        <span>
                          Buying Cost Per Month<span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      name="PurchaseRate"
                      rules={[
                        {
                          required: true,
                          message: "Please enter buying cost!",
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </div>
                  <div>
                    <Form.Item
                      style={{ marginBottom: "3rem", marginTop: "1rem" }}
                    >
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Button type="primary" htmlType="submit">
                          Submit
                        </Button>
                      </div>
                    </Form.Item>
                  </div>
                </div>
              </div>
              <Trade
                setInventories={setInventories}
                inventories={inventories}
                setAddInventoryBoolean={setAddInventoryBoolean}
              />
            </Form>
          </div>
        </div>
      </Modal>

      <Modal
        title="Block Inventories For"
        open={blockingModalOpen}
        onCancel={handleCancelBlockingModal}
        onOk={handleBlockInventories}
        confirmLoading={blockingSubmitLoading}
        okButtonProps={{ disabled: blockingSubmitLoading }}
      >
        <Form.Item label="Blocking Type">
          <Select
            defaultValue="normal"
            onChange={(value) => {
              setBlockingType(value);
              if (value === "normal") {
                setStartDate(null);
                setEndDate(null);
              }
            }}
            style={{ marginLeft: "8px", marginRight: "8px", width: "100%" }}
          >
            <Select.Option value="normal">Normal Blocking</Select.Option>

            <Select.Option value="premium">Premium Blocking</Select.Option>


            {isEliteUser(uId) && (
              <Select.Option value="management">
                Management Blocking
              </Select.Option>
            )}
          </Select>
        </Form.Item>

        {blockingType === "management" && (
          <Form.Item label="Blocking Dates">
            <RangePicker
              format="DD-MM-YYYY"
              onChange={(dates) => {
                if (dates) {
                  setStartDate(dates[0].toISOString());
                  setEndDate(dates[1].toISOString());
                } else {
                  setStartDate(null);
                  setEndDate(null);
                }
              }}
              disabledDate={(currentDate) =>
                isDateBlocked(
                  currentDate,
                  dataSource.filter(
                    (inventory) => checkedRecords[inventory._id],
                  ),
                )
              }
              cellRender={(currentDate) => {
                const premiumBlockedBy = isPremiumBlocked(
                  currentDate,
                  dataSource
                    .filter((inventory) => checkedRecords[inventory._id])
                    ?.flatMap((inventory) => inventory.blockedDates),
                );

                const isManagement = isManagementBlocked(
                  currentDate,
                  dataSource
                    .filter((inventory) => checkedRecords[inventory._id])
                    ?.flatMap((inventory) => inventory.blockedDates),
                );

                const isBlockedDate = !!premiumBlockedBy || !!isManagement;
                const blockType = premiumBlockedBy
                  ? "premium"
                  : isManagement
                    ? "management"
                    : null;

                const cellStyles = {
                  position: "relative",
                  zIndex: 1,
                  backgroundColor:
                    blockType === "premium"
                      ? "#f39c12" // Orange for premium
                      : blockType === "management"
                        ? "#d3d3d3" // Darker gray for management
                        : "transparent",
                  color:
                    blockType === "management"
                      ? "#000" // Black text for management
                      : isBlockedDate
                        ? "#fff" // White text for premium or other blocked types
                        : "inherit",
                  borderRadius: isBlockedDate ? "50%" : "0",
                  width: isBlockedDate ? "25px" : "auto",
                  height: isBlockedDate ? "25px" : "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  pointerEvents: "auto",
                };

                return (
                  <Tooltip
                    title={
                      premiumBlockedBy
                        ? `Blocked by ${premiumBlockedBy}`
                        : isManagement
                          ? `Blocked by Management`
                          : ""
                    }
                    placement="top"
                  >
                    <div style={cellStyles}>{currentDate.date()}</div>
                  </Tooltip>
                );
              }}
            />
          </Form.Item>
        )}


        <Form.Item label="Name of the client">
          {blockingType === "normal" ? (
            <AutoComplete
              options={clientDropdownOptions.map((c) => ({
                value: c.label, // what shows in input
                label: c.label,
              }))}
              value={clientName?.label ?? ""}
              onSelect={(value) => {
                // Selected from API list -> send blockedFor (ObjectId)
                const matched = clientDropdownOptions.find((c) => c.label === value);
                if (matched) setClientName({ value: matched.value, label: matched.label });
              }}
              onChange={(value) => {
                const next = (value ?? "").toString();

                // If the value matches an option label, keep it as a selected client (ObjectId).
                const matched = clientDropdownOptions.find((c) => c.label === next);
                if (matched) {
                  setClientName({ value: matched.value, label: matched.label });
                  return;
                }

                // Otherwise treat it as manual typing -> send partyName (string)
                setClientName(next ? { label: next.toUpperCase() } : null);
              }}
              onBlur={() => {
                // If user selected from dropdown, preserve `value` (ObjectId).
                if (clientName?.value) return;
                const partyName = (clientName?.label ?? "").trim().toUpperCase();
                setClientName(partyName ? { label: partyName } : null);
              }}
              placeholder="Select a client or type a name"
              style={{ width: "100%", textTransform: "uppercase" }}
              allowClear
              onClear={() => {
                onClear();
                setClientName(null);
              }}
              filterOption={(inputValue, option) =>
                (option?.label ?? "")
                  .toString()
                  .toLowerCase()
                  .includes((inputValue ?? "").toString().toLowerCase())
              }
            />
          ) : (
            <Select
              options={clientDropdownOptions}
              showSearch
              optionFilterProp="label"
              filterOption={(input, option) =>
                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
              }
              value={clientName?.value ?? undefined}
              onChange={(value, option) => {
                onSelect(value, option);
              }}
              placeholder="Select a client"
              style={{ width: "100%" }}
              allowClear
              onClear={() => {
                onClear();
                setClientName(null);
              }}
            />
          )}
        </Form.Item>


        {(blockingType === "normal" || blockingType === "management") && (
          <Form.Item label="Campaign Name">
            <Input
              value={campaignName}
              onChange={(e) =>
                setCampaignName(e.target.value.toUpperCase())
              }
              placeholder="Enter campaign name"
              style={{ textTransform: "uppercase" }}
            />
          </Form.Item>
        )}

        <Form.Item label="Confirmed By">
          <Input
            value={confirmedBy}
            placeholder="Mention the Name whos confirming this"
            onChange={(e) => setConfirmedBy(e.target.value)}
          />
        </Form.Item>
      </Modal>
      <style>
        {`
        .custom-modal-email .ant-modal-content {
          border-radius: 1% !important; /* Rounded corners */
          width: 596px !important; /* Fixed width */
          height: 615px !important; /* Fixed height */
          max-width: 100% !important; /* Ensure responsiveness */
          max-height: 100% !important; /* Ensure responsiveness */
          overflow: hidden; /* Hide overflow to maintain rounded corners */
          padding:0px
        }
        .custom-modal-email .ant-modal-header,
        .custom-modal-email .ant-modal-footer {
          border-radius: 20% 20% 0 0 !important; /* Rounded corners for header */
        }
        .custom-modal-email .ant-modal-close {
          border-radius: 50% !important; /* Optional: Round the close button */
        }
        .custom-modal-email .ant-modal-body {
          padding: 0px !important; /* Remove padding */
        }
        .custom-modal-email .ant-modal-content {
          border-radius: 1% !important;
          width: 596px !important;
          height: 615px !important;
          max-width: 100% !important;
          max-height: 100% !important;
          overflow: hidden !important;
          padding: 0px !important;
        }
        .custom-modal-email .custom-close-button {
          position: absolute;
          top: 4px; /* Adjust position */
          right: 12px; /* Adjust position */
          background: transparent;
          border: none;
          cursor: pointer;
          font-size: 18px; /* Size of the icon */
          color: #444746; /* Color of the icon */
          z-index: 1000; /* Ensure it’s on top */

        }
        .custom-modal-email .custom-close-button:hover,
        .custom-modal-email .custom-close-button:focus {
          color: #000 !important; /* Ensure color remains the same on hover and focus */
          background: transparent !important; /* Ensure background remains transparent */
          box-shadow: none !important; /* Remove any shadow */
          border: none !important; /* Remove any border */
        }
        .ant-select-selector.custom-dropdown {
        

          /* Add any additional custom styles here */
        }
      
      `}
      </style>
      <Modal
        visible={modalVisibleEmail}
        onOk={handleOkEmail}
        onCancel={handleCancelEmail}
        className="custom-modal-email" // Apply the custom class
        // This controls the padding of the outer modal wrapper
        footer={null}
        // Removes padding from the modal body
        closable={false}
        style={{
          padding: "0px",
          position: "relative",
        }}
      >
        <div style={{ height: "100%", width: "100%" }}>
          <div style={{ backgroundColor: "#F2F6FB" }}>
            <h6
              style={{ padding: "10px", fontFamily: "Google Sans, sans-serif" }}
            >
              New Message
            </h6>
            <button className="custom-close-button" onClick={handleCancelEmail}>
              {" "}
              <CloseOutlined />
            </button>
          </div>

          <div>
            <div className="custom-menu-email" style={{ padding: "10px" }}>
              <Select
                mode="tags"
                style={{
                  width: "100%",
                }}
                placeholder="Recipients"
                onChange={handleEmailSelect}
                value={selectedEmails}
                onInputKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleInputConfirm();
                  }
                }}
                onBlur={handleInputConfirm}
                className="custom-dropdown" // Optional: to style the dropdown menu
              >
                {emailOptions.map((email, index) => (
                  <Option key={index} value={email}>
                    {email}
                  </Option>
                ))}
              </Select>
              <br />
              <br />
              <Input
                style={{
                  marginBottom: "10px",
                  border: "none",
                  borderBottom: "1px solid #BFBFBF",
                  borderRadius: "0",
                }}
                placeholder="Enter the subject"
                value={subject}
                onChange={handleSubjectChange}
                onMouseOver={(e) =>
                  (e.currentTarget.style.borderBottom = "1px solid #BFBFBF")
                }
                onFocus={(e) => (e.currentTarget.style.border = "0px")}
                onMouseOut={(e) =>
                  (e.currentTarget.style.borderBottom = "1px solid #BFBFBF")
                }
              />
              <br />
              <div
                style={{ width: "500px", position: "relative", border: "0px" }}
              >
                <ReactQuill
                  value={bodyOfEmail}
                  onChange={handleTextArea}
                  placeholder="Content of the body"
                  modules={modules}
                  formats={formats}
                  style={{ height: "300px", border: "0px", outline: "none" }} // Remove border and outline
                />
                {/* Apply CSS to remove borders from the toolbar and editor */}
                <style jsx>{`
                  .ql-toolbar {
                    position: absolute;
                    bottom: -45px;
                    left: 0;
                    right: 0;
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    border: 0px !important; /* Ensure no border on toolbar */
                  }
                  .ql-container {
                    border: 0px !important; /* Remove border from editor container */
                  }
                  .ql-editor {
                    border: 0px !important; /* Remove border from the editable area */
                    outline: none; /* Remove any outline on focus */
                  }
                `}</style>
              </div>

              <br />
              <br />
              <hr />
              <br />
              <Button
                type="primary"
                onClick={handleOkEmail}
                style={{
                  borderRadius: "50px",
                  backgroundColor: "#0957D0",
                  borderColor: "#0957D0",
                }}
              >
                Send
              </Button>
            </div>
            <br />
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default InventoryContainer;
